/* tslint:disable */
/* eslint-disable */
/**
 * Ringo
 * Ringo API Documentation
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AddShoppingCartItemDTO {
    'quantity1'?: number;
    'quantity2'?: number;
    'commissionNumber'?: string;
    'note'?: string;
    'ring': Ring;
    'favoriteName1'?: string;
    'favoriteName2'?: string;
    'replaceItemId'?: string;
}
export interface AddressDTO {
    'id'?: string;
    'companyName': string;
    'street': string;
    'houseNumber'?: string;
    'postalCode': string;
    'city': string;
    'country': string;
    'telephone': string;
    'gender': AddressDTOGenderEnum;
    'firstName': string;
    'lastName': string;
    'type': AddressDTOTypeEnum;
    'verificationStatus': AddressDTOVerificationStatusEnum;
    'defaultAddress'?: boolean;
    'addressOriginType'?: AddressOriginType;
}

export const AddressDTOGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Divers: 'DIVERS'
} as const;

export type AddressDTOGenderEnum = typeof AddressDTOGenderEnum[keyof typeof AddressDTOGenderEnum];
export const AddressDTOTypeEnum = {
    Delivery: 'DELIVERY'
} as const;

export type AddressDTOTypeEnum = typeof AddressDTOTypeEnum[keyof typeof AddressDTOTypeEnum];
export const AddressDTOVerificationStatusEnum = {
    InProgress: 'IN_PROGRESS',
    Verified: 'VERIFIED',
    Rejected: 'REJECTED'
} as const;

export type AddressDTOVerificationStatusEnum = typeof AddressDTOVerificationStatusEnum[keyof typeof AddressDTOVerificationStatusEnum];


export const AddressOriginType = {
    SapSystem: 'SAP_SYSTEM',
    RingoDb: 'RINGO_DB'
} as const;

export type AddressOriginType = typeof AddressOriginType[keyof typeof AddressOriginType];


export interface AlloyDTO {
    'id'?: string;
    'materialNumber': string;
    'materialRingBlank'?: string;
    'materialProfileRing'?: string;
    'materialPipe'?: string;
    'metalGroup': AlloyDTOMetalGroupEnum;
    'colorEn': string;
    'colorDe': string;
    'hexColor': string;
    'auShare': number;
    'agShare': number;
    'pdShare': number;
    'ptShare': number;
    'density': number;
    'minMeltingPoint': number;
    'maxMeltingPoint': number;
    'hardness': number;
    'descriptionDe'?: string;
    'descriptionEn'?: string;
    'productGroups'?: Array<ProductGroup>;
    'solidus': number;
    'pdfUrlEn'?: string;
    'pdfUrlDe'?: string;
    'coc'?: boolean;
    'enabled'?: boolean;
    'hasTubeTolerance'?: boolean;
    'tubeTolerance'?: number;
}

export const AlloyDTOMetalGroupEnum = {
    Ag: 'AG',
    Au333: 'AU333',
    Au376: 'AU376',
    Au585: 'AU585',
    Au750: 'AU750',
    Au917: 'AU917',
    Au990: 'AU990',
    Pt: 'PT',
    Pd: 'PD',
    Coc: 'COC',
    NonPrecious: 'NON_PRECIOUS'
} as const;

export type AlloyDTOMetalGroupEnum = typeof AlloyDTOMetalGroupEnum[keyof typeof AlloyDTOMetalGroupEnum];

export interface AlloyDetails {
    'hexColor'?: string;
    'materialNumber'?: string;
    'minMeltingPoint'?: number;
    'metalGroup'?: AlloyDetailsMetalGroupEnum;
    'tubeTolerance'?: number;
    'hasTubeTolerance'?: boolean;
}

export const AlloyDetailsMetalGroupEnum = {
    Ag: 'AG',
    Au333: 'AU333',
    Au376: 'AU376',
    Au585: 'AU585',
    Au750: 'AU750',
    Au917: 'AU917',
    Au990: 'AU990',
    Pt: 'PT',
    Pd: 'PD',
    Coc: 'COC',
    NonPrecious: 'NON_PRECIOUS'
} as const;

export type AlloyDetailsMetalGroupEnum = typeof AlloyDetailsMetalGroupEnum[keyof typeof AlloyDetailsMetalGroupEnum];

export interface AlloyWeight {
    'auShareWeight': number;
    'agShareWeight': number;
    'ptShareWeight': number;
    'pdShareWeight': number;
    'weight': number;
}
export interface ApplyCouponRequest {
    'couponCode': string;
}
export interface ApplyCouponResponse {
    'errorMessage'?: string;
    'success'?: boolean;
}
export interface ApprovalDto {
    'id'?: string;
    'user': UserDTO;
    'reviewedBy'?: string;
    'status'?: ApprovalDtoStatusEnum;
    'reviewDate'?: string;
    'type'?: ApprovalDtoTypeEnum;
    'filesUploaded'?: boolean;
    'masterData'?: MasterDataDTO;
    'notification'?: boolean;
    'createdDate'?: string;
    'lastModifiedDate'?: string;
    'files'?: Array<string>;
}

export const ApprovalDtoStatusEnum = {
    New: 'NEW',
    WaitingForSapResponse: 'WAITING_FOR_SAP_RESPONSE',
    Approved: 'APPROVED',
    Rejected: 'REJECTED'
} as const;

export type ApprovalDtoStatusEnum = typeof ApprovalDtoStatusEnum[keyof typeof ApprovalDtoStatusEnum];
export const ApprovalDtoTypeEnum = {
    Registration: 'REGISTRATION',
    MasterDataChange: 'MASTER_DATA_CHANGE'
} as const;

export type ApprovalDtoTypeEnum = typeof ApprovalDtoTypeEnum[keyof typeof ApprovalDtoTypeEnum];

export interface AxialSinteringConfig {
    'type': AxialSinteringConfigTypeEnum;
    'sliceCount': number;
    'ringDimensions': RingDimensions;
    'outerSlice': AxialSinteringSlice;
    'innerSlice': AxialSinteringSlice;
}

export const AxialSinteringConfigTypeEnum = {
    AxialSintering: 'AXIAL_SINTERING',
    NormalSintering: 'NORMAL_SINTERING',
    Profil: 'PROFIL',
    Tube: 'TUBE'
} as const;

export type AxialSinteringConfigTypeEnum = typeof AxialSinteringConfigTypeEnum[keyof typeof AxialSinteringConfigTypeEnum];

export interface AxialSinteringSlice {
    'priceCalculationType'?: AxialSinteringSlicePriceCalculationTypeEnum;
    'alloyId': string;
    'alloyDetails'?: AlloyDetails;
    'thickness': number;
    'diameter'?: number;
    'oversize': Oversize;
    'volume'?: number;
    'alloyWeight'?: AlloyWeight;
    'uniqueRingId'?: string;
    'metalCost'?: MetalCost;
}

export const AxialSinteringSlicePriceCalculationTypeEnum = {
    ByWeight: 'BY_WEIGHT',
    ByQuantity: 'BY_QUANTITY',
    ByCustomerQuantity: 'BY_CUSTOMER_QUANTITY',
    ByTubeWeight: 'BY_TUBE_WEIGHT'
} as const;

export type AxialSinteringSlicePriceCalculationTypeEnum = typeof AxialSinteringSlicePriceCalculationTypeEnum[keyof typeof AxialSinteringSlicePriceCalculationTypeEnum];

export interface BevelEdge {
    'type': BevelEdgeTypeEnum;
    'radius'?: number;
}

export const BevelEdgeTypeEnum = {
    Bevel: 'BEVEL'
} as const;

export type BevelEdgeTypeEnum = typeof BevelEdgeTypeEnum[keyof typeof BevelEdgeTypeEnum];

export interface BuildProperties {
    'name'?: string;
    'time'?: string;
    'version'?: string;
    'artifact'?: string;
    'group'?: string;
}
/**
 * @type CalcResponse
 */
export type CalcResponse = CalculateResponse | PairCalculateResponse;

/**
 * @type CalculateRequest
 */
export type CalculateRequest = PairRing | SingleRing;

export interface CalculateResponse {
    'priceCalculationError'?: boolean;
    'type'?: CalculateResponseTypeEnum;
    'ringPrice'?: RingPrice;
    'weight'?: RingWeight;
    'itemWarnings'?: Array<ItemWarning>;
}

export const CalculateResponseTypeEnum = {
    Single: 'SINGLE',
    Pair: 'PAIR'
} as const;

export type CalculateResponseTypeEnum = typeof CalculateResponseTypeEnum[keyof typeof CalculateResponseTypeEnum];

export interface CamberedMold {
    'type'?: CamberedMoldTypeEnum;
}

export const CamberedMoldTypeEnum = {
    Cambered: 'CAMBERED'
} as const;

export type CamberedMoldTypeEnum = typeof CamberedMoldTypeEnum[keyof typeof CamberedMoldTypeEnum];

export interface ChangePasswordDto {
    'oldPassword': string;
    'newPassword': string;
    'confirmPassword': string;
}
export interface CheckToken {
    'token': string;
}
export interface ConfirmAddressDto {
    'token': string;
}
export interface ConfirmAddressResultDto {
    'result'?: boolean;
}
export interface ConfirmEmailResultDto {
    'result'?: boolean;
}
export interface CustomWidth {
    'type': CustomWidthTypeEnum;
    'width': number;
}

export const CustomWidthTypeEnum = {
    CustomWidth: 'CUSTOM_WIDTH'
} as const;

export type CustomWidthTypeEnum = typeof CustomWidthTypeEnum[keyof typeof CustomWidthTypeEnum];

export interface Diameter {
    'type': DiameterTypeEnum;
    'diameter': number;
}

export const DiameterTypeEnum = {
    Diameter: 'DIAMETER'
} as const;

export type DiameterTypeEnum = typeof DiameterTypeEnum[keyof typeof DiameterTypeEnum];


export const DiscountType = {
    Percentage: 'PERCENTAGE',
    Amount: 'AMOUNT'
} as const;

export type DiscountType = typeof DiscountType[keyof typeof DiscountType];


export interface DownloadToken {
    'ott'?: string;
}
/**
 * @type Edge
 */
export type Edge = BevelEdge | NoEdge | RoundEdge;

export interface EmailTokenDto {
    'token': string;
}
export interface England {
    'type': EnglandTypeEnum;
    'width': EnglandWidthEnum;
}

export const EnglandTypeEnum = {
    England: 'ENGLAND'
} as const;

export type EnglandTypeEnum = typeof EnglandTypeEnum[keyof typeof EnglandTypeEnum];
export const EnglandWidthEnum = {
    D: 'D',
    DHalf: 'D_HALF',
    E: 'E',
    EHalf: 'E_HALF',
    F: 'F',
    FHalf: 'F_HALF',
    G: 'G',
    GHalf: 'G_HALF',
    H: 'H',
    HHalf: 'H_HALF',
    I: 'I',
    J: 'J',
    JHalf: 'J_HALF',
    K: 'K',
    KHalf: 'K_HALF',
    L: 'L',
    LHalf: 'L_HALF',
    M: 'M',
    MHalf: 'M_HALF',
    N: 'N',
    NHalf: 'N_HALF',
    O: 'O',
    OHalf: 'O_HALF',
    P: 'P',
    PHalf: 'P_HALF',
    Q: 'Q',
    QHalf: 'Q_HALF',
    R: 'R',
    RHalf: 'R_HALF',
    S: 'S',
    SHalf: 'S_HALF',
    T: 'T',
    THalf: 'T_HALF',
    U: 'U',
    UHalf: 'U_HALF',
    V: 'V',
    VHalf: 'V_HALF',
    W: 'W',
    WHalf: 'W_HALF',
    X: 'X',
    XHalf: 'X_HALF',
    Y: 'Y',
    Z: 'Z',
    ZHalf: 'Z_HALF',
    Z1: 'Z1',
    Z2: 'Z2',
    Z3: 'Z3',
    Z4: 'Z4'
} as const;

export type EnglandWidthEnum = typeof EnglandWidthEnum[keyof typeof EnglandWidthEnum];

export interface FavoriteDTO {
    'id'?: string;
    'name': string;
    'note'?: string;
    'ring': SingleRing;
}
export interface FileDTO {
    'id': string;
    'userId': string;
    'originalFilename': string;
    'contentType': string;
    'size': number;
    'documentType': FileDTODocumentTypeEnum;
}

export const FileDTODocumentTypeEnum = {
    Gewerbeanmeldung: 'GEWERBEANMELDUNG',
    Ausweis: 'AUSWEIS',
    Kundenstammblatt: 'KUNDENSTAMMBLATT',
    StammdatenAenderungsNachweis: 'STAMMDATEN_AENDERUNGS_NACHWEIS'
} as const;

export type FileDTODocumentTypeEnum = typeof FileDTODocumentTypeEnum[keyof typeof FileDTODocumentTypeEnum];

export interface FlatMold {
    'type'?: FlatMoldTypeEnum;
    'decreaseWall': number;
}

export const FlatMoldTypeEnum = {
    Flat: 'FLAT'
} as const;

export type FlatMoldTypeEnum = typeof FlatMoldTypeEnum[keyof typeof FlatMoldTypeEnum];

export interface ForgotPasswordFinishDto {
    'newPassword'?: string;
    'confirmNewPassword': string;
    'token': string;
}
export interface ForgotPasswordInitDto {
    'email': string;
    'hcaptchaPasscode': string;
}
export interface Invoice {
    'ringoPdf'?: OrderPdfDto;
    'sapInvoiceDtoList'?: Array<SapInvoiceDto>;
}
/**
 * @type ItemWarning
 */
export type ItemWarning = PriceChangeWarning | TubeMinOrderWeight;

export interface JWTToken {
    'token'?: string;
    'email2FAEnabled'?: boolean;
}
export interface LanguageDTO {
    'langKey': LanguageDTOLangKeyEnum;
    'docLangKey': LanguageDTODocLangKeyEnum;
}

export const LanguageDTOLangKeyEnum = {
    En: 'EN',
    Fr: 'FR',
    De: 'DE',
    Es: 'ES',
    Sr: 'SR',
    Zh: 'ZH',
    Th: 'TH',
    Ko: 'KO',
    Ro: 'RO',
    Sl: 'SL',
    Hr: 'HR',
    Ms: 'MS',
    Uk: 'UK',
    Et: 'ET',
    Ar: 'AR',
    He: 'HE',
    Cz: 'CZ',
    El: 'EL',
    Hu: 'HU',
    It: 'IT',
    Ja: 'JA',
    Da: 'DA',
    Pl: 'PL',
    Zf: 'ZF',
    No: 'NO',
    Pt: 'PT',
    Sk: 'SK',
    Ru: 'RU',
    Tr: 'TR',
    Fi: 'FI',
    Sv: 'SV',
    Bg: 'BG',
    Lt: 'LT',
    Lv: 'LV',
    Z1: 'Z1',
    Af: 'AF',
    Is: 'IS',
    Ca: 'CA',
    Sh: 'SH',
    Id: 'ID',
    Nl: 'NL'
} as const;

export type LanguageDTOLangKeyEnum = typeof LanguageDTOLangKeyEnum[keyof typeof LanguageDTOLangKeyEnum];
export const LanguageDTODocLangKeyEnum = {
    En: 'EN',
    Fr: 'FR',
    De: 'DE',
    Es: 'ES',
    Sr: 'SR',
    Zh: 'ZH',
    Th: 'TH',
    Ko: 'KO',
    Ro: 'RO',
    Sl: 'SL',
    Hr: 'HR',
    Ms: 'MS',
    Uk: 'UK',
    Et: 'ET',
    Ar: 'AR',
    He: 'HE',
    Cz: 'CZ',
    El: 'EL',
    Hu: 'HU',
    It: 'IT',
    Ja: 'JA',
    Da: 'DA',
    Pl: 'PL',
    Zf: 'ZF',
    No: 'NO',
    Pt: 'PT',
    Sk: 'SK',
    Ru: 'RU',
    Tr: 'TR',
    Fi: 'FI',
    Sv: 'SV',
    Bg: 'BG',
    Lt: 'LT',
    Lv: 'LV',
    Z1: 'Z1',
    Af: 'AF',
    Is: 'IS',
    Ca: 'CA',
    Sh: 'SH',
    Id: 'ID',
    Nl: 'NL'
} as const;

export type LanguageDTODocLangKeyEnum = typeof LanguageDTODocLangKeyEnum[keyof typeof LanguageDTODocLangKeyEnum];

export interface Link {
    'href'?: string;
    'templated'?: boolean;
}
export interface Login2FA {
    'username': string;
    'password': string;
    'emailCode': string;
    'rememberPassword'?: boolean;
    'hcaptchaPasscode': string;
}
export interface LoginDto {
    'username': string;
    'password': string;
    'rememberPassword'?: boolean;
    'hcaptchaPasscode': string;
}
export interface MachineryFormCost {
    'baseFormCost': number;
    'totalFormCost': number;
    'costPerGram': number;
    'widthFee': number;
    'wallFee': number;
    'sideBySideFee': number;
    'axialFee': number;
    'mfkMap'?: { [key: string]: MfkPair; };
}

export const MailjetSemaphorStatus = {
    White: 'WHITE',
    Red: 'RED',
    Yellow: 'YELLOW',
    Green: 'GREEN'
} as const;

export type MailjetSemaphorStatus = typeof MailjetSemaphorStatus[keyof typeof MailjetSemaphorStatus];


export interface ManufacturingCost {
    'machineryFormCost': MachineryFormCost;
    'unitCost': UnitCost;
    'totalManufacturingCost': number;
    'discount': number;
    'totalManufacturingCostWithDiscount': number;
}
export interface MasterDataDTO {
    'id'?: string;
    'companyName': string;
    'street': string;
    'houseNumber'?: string;
    'postalCode': string;
    'city': string;
    'country': string;
    'telephone'?: string;
    'gender': MasterDataDTOGenderEnum;
    'firstName': string;
    'lastName': string;
    'verificationStatus'?: MasterDataDTOVerificationStatusEnum;
    'accountGroup'?: string;
}

export const MasterDataDTOGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Divers: 'DIVERS'
} as const;

export type MasterDataDTOGenderEnum = typeof MasterDataDTOGenderEnum[keyof typeof MasterDataDTOGenderEnum];
export const MasterDataDTOVerificationStatusEnum = {
    InProgress: 'IN_PROGRESS',
    Verified: 'VERIFIED',
    Rejected: 'REJECTED'
} as const;

export type MasterDataDTOVerificationStatusEnum = typeof MasterDataDTOVerificationStatusEnum[keyof typeof MasterDataDTOVerificationStatusEnum];

export interface MasterDataResponseDto {
    'defaultData'?: MasterDataDTO;
    'approvalDto'?: ApprovalDto;
}
export interface MetalCost {
    'auSharePrice'?: number;
    'agSharePrice'?: number;
    'ptSharePrice'?: number;
    'pdSharePrice'?: number;
    'vvFee'?: number;
    'vvFeePercentage'?: number;
    'baseMetalCost'?: number;
    'totalMetalCost'?: number;
}
export interface MetalPrice {
    'auPrice'?: number;
    'agPrice'?: number;
    'ptPrice'?: number;
    'pdPrice'?: number;
}
export interface MfkPair {
    'mfk'?: MfkPairMfkEnum;
    'mfkPrice'?: number;
}

export const MfkPairMfkEnum = {
    OverMfk: 'OVER_MFK',
    UnderMfk: 'UNDER_MFK'
} as const;

export type MfkPairMfkEnum = typeof MfkPairMfkEnum[keyof typeof MfkPairMfkEnum];

/**
 * @type Mold
 */
export type Mold = CamberedMold | FlatMold | NoMold;

export interface NoEdge {
    'type'?: NoEdgeTypeEnum;
}

export const NoEdgeTypeEnum = {
    Keine: 'KEINE'
} as const;

export type NoEdgeTypeEnum = typeof NoEdgeTypeEnum[keyof typeof NoEdgeTypeEnum];

export interface NoMold {
    'type'?: NoMoldTypeEnum;
}

export const NoMoldTypeEnum = {
    No: 'NO'
} as const;

export type NoMoldTypeEnum = typeof NoMoldTypeEnum[keyof typeof NoMoldTypeEnum];

export interface NormalSinteringConfig {
    'type': NormalSinteringConfigTypeEnum;
    'slices': Array<NormalSinteringSlice>;
    'ringDimensions': RingDimensions;
    'sliceCount': number;
    'split': NormalSinteringConfigSplitEnum;
}

export const NormalSinteringConfigTypeEnum = {
    AxialSintering: 'AXIAL_SINTERING',
    NormalSintering: 'NORMAL_SINTERING',
    Profil: 'PROFIL',
    Tube: 'TUBE'
} as const;

export type NormalSinteringConfigTypeEnum = typeof NormalSinteringConfigTypeEnum[keyof typeof NormalSinteringConfigTypeEnum];
export const NormalSinteringConfigSplitEnum = {
    Free: 'FREE',
    Ratio1To1: 'RATIO_1_TO_1',
    Ratio12: 'RATIO_1_2',
    Ratio21: 'RATIO_2_1',
    Ratio13: 'RATIO_1_3',
    Ratio31: 'RATIO_3_1',
    Ratio111: 'RATIO_1_1_1',
    Ratio212: 'RATIO_2_1_2',
    Ratio121: 'RATIO_1_2_1',
    Ratio211: 'RATIO_2_1_1',
    Ration1111: 'RATION_1_1_1_1',
    Ration21212: 'RATION_2_1_2_1_2'
} as const;

export type NormalSinteringConfigSplitEnum = typeof NormalSinteringConfigSplitEnum[keyof typeof NormalSinteringConfigSplitEnum];

export interface NormalSinteringSlice {
    'priceCalculationType'?: NormalSinteringSlicePriceCalculationTypeEnum;
    'alloyId': string;
    'alloyDetails'?: AlloyDetails;
    'alloyWidth': number;
    'oversize': Oversize;
    'volume'?: number;
    'alloyWeight'?: AlloyWeight;
    'uniqueRingId'?: string;
    'metalCost'?: MetalCost;
}

export const NormalSinteringSlicePriceCalculationTypeEnum = {
    ByWeight: 'BY_WEIGHT',
    ByQuantity: 'BY_QUANTITY',
    ByCustomerQuantity: 'BY_CUSTOMER_QUANTITY',
    ByTubeWeight: 'BY_TUBE_WEIGHT'
} as const;

export type NormalSinteringSlicePriceCalculationTypeEnum = typeof NormalSinteringSlicePriceCalculationTypeEnum[keyof typeof NormalSinteringSlicePriceCalculationTypeEnum];

/**
 * @type Nut
 */
export type Nut = UNut | VNut55;

export interface OrderDTO {
    'id'?: string;
    'user'?: UserDTO;
    'commissionNumber'?: string;
    'note'?: string;
    'shippingDateWish'?: string;
    'orderDate'?: string;
    'status'?: OrderDTOStatusEnum;
    'chargeAu': boolean;
    'chargeAg': boolean;
    'chargePt': boolean;
    'chargePd': boolean;
    'sapOrderId'?: string;
    'cartItems'?: Array<ShoppingCartItemDTO>;
    'deliveryAddress'?: AddressDTO;
    'invoiceAddress'?: MasterDataDTO;
    'chargeUsingMetalAccount'?: OrderDTOChargeUsingMetalAccountEnum;
    'totalAmount'?: number;
    'totalMetalCost'?: number;
    'totalFormCost'?: number;
    'totalUnitCost'?: number;
    'totalManufacturingCost'?: number;
    'totalDiscount'?: number;
    'totalManufacturingCostWithDiscount'?: number;
    'orderId'?: string;
    'coupon'?: UserCouponDto;
    'legacyOrder'?: boolean;
}

export const OrderDTOStatusEnum = {
    Initial: 'INITIAL',
    Ordered: 'ORDERED',
    InProgress: 'IN_PROGRESS',
    Complete: 'COMPLETE',
    Cancelled: 'CANCELLED'
} as const;

export type OrderDTOStatusEnum = typeof OrderDTOStatusEnum[keyof typeof OrderDTOStatusEnum];
export const OrderDTOChargeUsingMetalAccountEnum = {
    Yes: 'YES',
    No: 'NO'
} as const;

export type OrderDTOChargeUsingMetalAccountEnum = typeof OrderDTOChargeUsingMetalAccountEnum[keyof typeof OrderDTOChargeUsingMetalAccountEnum];

export interface OrderPdfDto {
    'id'?: string;
    'size': number;
    'contentType': string;
    'fileName': string;
}
export interface Oversize {
    'widthOversize': number;
    'wallOversize': number;
    'bandOversize': number;
}
export interface PairCalculateResponse {
    'priceCalculationError'?: boolean;
    'type'?: PairCalculateResponseTypeEnum;
    'calculateResponse1'?: CalculateResponse;
    'calculateResponse2'?: CalculateResponse;
    'itemWarnings'?: Array<ItemWarning>;
}

export const PairCalculateResponseTypeEnum = {
    Single: 'SINGLE',
    Pair: 'PAIR'
} as const;

export type PairCalculateResponseTypeEnum = typeof PairCalculateResponseTypeEnum[keyof typeof PairCalculateResponseTypeEnum];

export interface PairRing {
    'type': PairRingTypeEnum;
    'ringConfig1': RingConfig;
    'ringConfig2': RingConfig;
    'linked': boolean;
}

export const PairRingTypeEnum = {
    PairRing: 'PAIR_RING'
} as const;

export type PairRingTypeEnum = typeof PairRingTypeEnum[keyof typeof PairRingTypeEnum];

export interface PairShoppingCartItemDTO {
    'id': string;
    'commissionNumber'?: string;
    'note'?: string;
    'priceCalculationError'?: boolean;
    'totalPrice': number;
    'itemWarnings': Array<ItemWarning>;
    'type': PairShoppingCartItemDTOTypeEnum;
    'quantity1'?: number;
    'quantity2'?: number;
    'ringPrice1': RingPrice;
    'ringPrice2': RingPrice;
    'pairRing': PairRing;
    'ringWeight1'?: RingWeight;
    'ringWeight2'?: RingWeight;
    'favoriteName1'?: string;
    'favoriteName2'?: string;
}

export const PairShoppingCartItemDTOTypeEnum = {
    PairItem: 'PAIR_ITEM'
} as const;

export type PairShoppingCartItemDTOTypeEnum = typeof PairShoppingCartItemDTOTypeEnum[keyof typeof PairShoppingCartItemDTOTypeEnum];

export interface PlaceOrderDTO {
    'currentTotalPrice': number;
    'deliveryAddressId': string;
    'shippingDateWish'?: string;
    'acceptTermsAndConditions'?: boolean;
    'chargeUsingMetalAccount': PlaceOrderDTOChargeUsingMetalAccountEnum;
    'chargeAu'?: boolean;
    'chargeAg'?: boolean;
    'chargePt'?: boolean;
    'chargePd'?: boolean;
}

export const PlaceOrderDTOChargeUsingMetalAccountEnum = {
    Yes: 'YES',
    No: 'NO'
} as const;

export type PlaceOrderDTOChargeUsingMetalAccountEnum = typeof PlaceOrderDTOChargeUsingMetalAccountEnum[keyof typeof PlaceOrderDTOChargeUsingMetalAccountEnum];

export interface PriceChangeWarning {
    'type'?: PriceChangeWarningTypeEnum;
    'oldPrice'?: number;
}

export const PriceChangeWarningTypeEnum = {
    TubeMinOrderWeight: 'TUBE_MIN_ORDER_WEIGHT',
    PriceChange: 'PRICE_CHANGE'
} as const;

export type PriceChangeWarningTypeEnum = typeof PriceChangeWarningTypeEnum[keyof typeof PriceChangeWarningTypeEnum];

export interface ProblemDetail {
    'type'?: string;
    'title'?: string;
    'status'?: number;
    'detail'?: string;
    'instance'?: string;
    'properties'?: { [key: string]: object; };
}

export const ProductGroup = {
    Profil: 'PROFIL',
    Tube: 'TUBE',
    Blank: 'BLANK',
    CanBeSintered: 'CAN_BE_SINTERED'
} as const;

export type ProductGroup = typeof ProductGroup[keyof typeof ProductGroup];


export interface ProfilRingConfig {
    'type': ProfilRingConfigTypeEnum;
    'ringDimensions': RingDimensions;
    'alloyId': string;
    'alloyDetails'?: AlloyDetails;
    'priceCalculationType'?: ProfilRingConfigPriceCalculationTypeEnum;
    'ringProfil': RingProfil;
    'nut': Array<Nut>;
    'volume'?: number;
    'alloyWeight'?: AlloyWeight;
}

export const ProfilRingConfigTypeEnum = {
    AxialSintering: 'AXIAL_SINTERING',
    NormalSintering: 'NORMAL_SINTERING',
    Profil: 'PROFIL',
    Tube: 'TUBE'
} as const;

export type ProfilRingConfigTypeEnum = typeof ProfilRingConfigTypeEnum[keyof typeof ProfilRingConfigTypeEnum];
export const ProfilRingConfigPriceCalculationTypeEnum = {
    ByWeight: 'BY_WEIGHT',
    ByQuantity: 'BY_QUANTITY',
    ByCustomerQuantity: 'BY_CUSTOMER_QUANTITY',
    ByTubeWeight: 'BY_TUBE_WEIGHT'
} as const;

export type ProfilRingConfigPriceCalculationTypeEnum = typeof ProfilRingConfigPriceCalculationTypeEnum[keyof typeof ProfilRingConfigPriceCalculationTypeEnum];

export interface RegisterDTO {
    'firstName': string;
    'lastName': string;
    'gender': RegisterDTOGenderEnum;
    'customerNumber'?: string;
    'email'?: string;
    'password'?: string;
    'langKey': RegisterDTOLangKeyEnum;
    'docLangKey': RegisterDTODocLangKeyEnum;
    'companyName': string;
    'street': string;
    'houseNumber'?: string;
    'postalCode': string;
    'city': string;
    'country': string;
    'telephone'?: string;
    'acceptAGBs': boolean;
    'heimerleMeuleCustomer': RegisterDTOHeimerleMeuleCustomerEnum;
    'hcaptchaPasscode': string;
}

export const RegisterDTOGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    Divers: 'DIVERS'
} as const;

export type RegisterDTOGenderEnum = typeof RegisterDTOGenderEnum[keyof typeof RegisterDTOGenderEnum];
export const RegisterDTOLangKeyEnum = {
    En: 'EN',
    Fr: 'FR',
    De: 'DE',
    Es: 'ES',
    Sr: 'SR',
    Zh: 'ZH',
    Th: 'TH',
    Ko: 'KO',
    Ro: 'RO',
    Sl: 'SL',
    Hr: 'HR',
    Ms: 'MS',
    Uk: 'UK',
    Et: 'ET',
    Ar: 'AR',
    He: 'HE',
    Cz: 'CZ',
    El: 'EL',
    Hu: 'HU',
    It: 'IT',
    Ja: 'JA',
    Da: 'DA',
    Pl: 'PL',
    Zf: 'ZF',
    No: 'NO',
    Pt: 'PT',
    Sk: 'SK',
    Ru: 'RU',
    Tr: 'TR',
    Fi: 'FI',
    Sv: 'SV',
    Bg: 'BG',
    Lt: 'LT',
    Lv: 'LV',
    Z1: 'Z1',
    Af: 'AF',
    Is: 'IS',
    Ca: 'CA',
    Sh: 'SH',
    Id: 'ID',
    Nl: 'NL'
} as const;

export type RegisterDTOLangKeyEnum = typeof RegisterDTOLangKeyEnum[keyof typeof RegisterDTOLangKeyEnum];
export const RegisterDTODocLangKeyEnum = {
    En: 'EN',
    Fr: 'FR',
    De: 'DE',
    Es: 'ES',
    Sr: 'SR',
    Zh: 'ZH',
    Th: 'TH',
    Ko: 'KO',
    Ro: 'RO',
    Sl: 'SL',
    Hr: 'HR',
    Ms: 'MS',
    Uk: 'UK',
    Et: 'ET',
    Ar: 'AR',
    He: 'HE',
    Cz: 'CZ',
    El: 'EL',
    Hu: 'HU',
    It: 'IT',
    Ja: 'JA',
    Da: 'DA',
    Pl: 'PL',
    Zf: 'ZF',
    No: 'NO',
    Pt: 'PT',
    Sk: 'SK',
    Ru: 'RU',
    Tr: 'TR',
    Fi: 'FI',
    Sv: 'SV',
    Bg: 'BG',
    Lt: 'LT',
    Lv: 'LV',
    Z1: 'Z1',
    Af: 'AF',
    Is: 'IS',
    Ca: 'CA',
    Sh: 'SH',
    Id: 'ID',
    Nl: 'NL'
} as const;

export type RegisterDTODocLangKeyEnum = typeof RegisterDTODocLangKeyEnum[keyof typeof RegisterDTODocLangKeyEnum];
export const RegisterDTOHeimerleMeuleCustomerEnum = {
    Yes: 'YES',
    No: 'NO'
} as const;

export type RegisterDTOHeimerleMeuleCustomerEnum = typeof RegisterDTOHeimerleMeuleCustomerEnum[keyof typeof RegisterDTOHeimerleMeuleCustomerEnum];

export interface Resend2FaPublic {
    'username'?: string;
    'password'?: string;
}
export interface RestPageFavoriteDTO {
    'content'?: Array<FavoriteDTO>;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface RestPageOrderDTO {
    'content'?: Array<OrderDTO>;
    'totalElements'?: number;
    'totalPages'?: number;
}
/**
 * @type Ring
 */
export type Ring = PairRing | SingleRing;

/**
 * @type RingConfig
 */
export type RingConfig = AxialSinteringConfig | NormalSinteringConfig | ProfilRingConfig | TubeConfig;

export interface RingDimensions {
    'ringWidth': number;
    'wallThickness': number;
    'ringSize': RingSize;
}
export interface RingPrice {
    'manufacturingCost': ManufacturingCost;
    'metalCost': MetalCost;
    'totalRingPrice': number;
}
/**
 * @type RingProfil
 */
export type RingProfil = RingProfil0 | RingProfil0C | RingProfil1 | RingProfil10 | RingProfil11 | RingProfil12 | RingProfil13 | RingProfil14 | RingProfil16 | RingProfil17 | RingProfil2 | RingProfil3 | RingProfil4 | RingProfil5 | RingProfil6 | RingProfil7 | RingProfil71 | RingProfil8 | RingProfil9;

export interface RingProfil0 {
    'type'?: RingProfil0TypeEnum;
    'sideHeight': number;
}

export const RingProfil0TypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil0TypeEnum = typeof RingProfil0TypeEnum[keyof typeof RingProfil0TypeEnum];

export interface RingProfil0C {
    'type'?: RingProfil0CTypeEnum;
    'edgeOuter': Edge;
    'edgeInner': Edge;
    'sideHeight': number;
}

export const RingProfil0CTypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil0CTypeEnum = typeof RingProfil0CTypeEnum[keyof typeof RingProfil0CTypeEnum];

export interface RingProfil1 {
    'type'?: RingProfil1TypeEnum;
    'moldInner': number;
    'moldOuter': number;
    'edgeOuter': Edge;
    'edgeInner': Edge;
    'radiusInner': number;
    'radiusOuter': number;
    'sideHeight': number;
}

export const RingProfil1TypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil1TypeEnum = typeof RingProfil1TypeEnum[keyof typeof RingProfil1TypeEnum];

export interface RingProfil10 {
    'type'?: RingProfil10TypeEnum;
    'moldInner': number;
    'moldOuter': number;
    'radiusInner': number;
    'radiusOuter': number;
}

export const RingProfil10TypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil10TypeEnum = typeof RingProfil10TypeEnum[keyof typeof RingProfil10TypeEnum];

export interface RingProfil11 {
    'type'?: RingProfil11TypeEnum;
    'moldInner': number;
    'moldOuter': number;
    'radiusInner': number;
    'radiusOuter': number;
}

export const RingProfil11TypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil11TypeEnum = typeof RingProfil11TypeEnum[keyof typeof RingProfil11TypeEnum];

export interface RingProfil12 {
    'type'?: RingProfil12TypeEnum;
}

export const RingProfil12TypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil12TypeEnum = typeof RingProfil12TypeEnum[keyof typeof RingProfil12TypeEnum];

export interface RingProfil13 {
    'type'?: RingProfil13TypeEnum;
}

export const RingProfil13TypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil13TypeEnum = typeof RingProfil13TypeEnum[keyof typeof RingProfil13TypeEnum];

export interface RingProfil14 {
    'type'?: RingProfil14TypeEnum;
    'edgeInner': Edge;
    'radiusOuter': number;
}

export const RingProfil14TypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil14TypeEnum = typeof RingProfil14TypeEnum[keyof typeof RingProfil14TypeEnum];

export interface RingProfil16 {
    'type'?: RingProfil16TypeEnum;
    'edgeOuter': Edge;
    'radiusInner': number;
}

export const RingProfil16TypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil16TypeEnum = typeof RingProfil16TypeEnum[keyof typeof RingProfil16TypeEnum];

export interface RingProfil17 {
    'type'?: RingProfil17TypeEnum;
    'edgeInner': Edge;
    'moldInner': number;
    'moldOuter': number;
    'angle': number;
    'radiusInner': number;
    'radiusOuter': number;
    'sideHeight': number;
}

export const RingProfil17TypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil17TypeEnum = typeof RingProfil17TypeEnum[keyof typeof RingProfil17TypeEnum];

export interface RingProfil2 {
    'type'?: RingProfil2TypeEnum;
    'moldInner': number;
    'moldOuter': number;
    'edgeOuter': Edge;
    'edgeInner': Edge;
    'radiusInner': number;
    'radiusOuter': number;
    'sideHeight': number;
}

export const RingProfil2TypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil2TypeEnum = typeof RingProfil2TypeEnum[keyof typeof RingProfil2TypeEnum];

export interface RingProfil3 {
    'type'?: RingProfil3TypeEnum;
    'moldOuter': number;
    'edgeOuter': Edge;
    'edgeInner': Edge;
    'radiusOuter': number;
    'sideHeight': number;
}

export const RingProfil3TypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil3TypeEnum = typeof RingProfil3TypeEnum[keyof typeof RingProfil3TypeEnum];

export interface RingProfil4 {
    'type'?: RingProfil4TypeEnum;
    'moldInner': number;
    'edgeOuter': Edge;
    'edgeInner': Edge;
    'radiusInner': number;
    'sideHeight': number;
}

export const RingProfil4TypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil4TypeEnum = typeof RingProfil4TypeEnum[keyof typeof RingProfil4TypeEnum];

export interface RingProfil5 {
    'type'?: RingProfil5TypeEnum;
    'moldOuter': number;
    'radiusInner': number;
    'radiusOuter': number;
}

export const RingProfil5TypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil5TypeEnum = typeof RingProfil5TypeEnum[keyof typeof RingProfil5TypeEnum];

export interface RingProfil6 {
    'type'?: RingProfil6TypeEnum;
    'edgeInner': Edge;
    'sideHeight': number;
}

export const RingProfil6TypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil6TypeEnum = typeof RingProfil6TypeEnum[keyof typeof RingProfil6TypeEnum];

export interface RingProfil7 {
    'type'?: RingProfil7TypeEnum;
    'moldInner': number;
    'moldOuter': number;
    'edgeInner': Edge;
    'radiusInner': number;
    'radiusOuter': number;
    'sideHeight': number;
}

export const RingProfil7TypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil7TypeEnum = typeof RingProfil7TypeEnum[keyof typeof RingProfil7TypeEnum];

export interface RingProfil71 {
    'type'?: RingProfil71TypeEnum;
    'moldInner': number;
    'moldOuter': number;
    'angle': number;
    'radiusInner': number;
    'radiusOuter': number;
    'sideHeight': number;
}

export const RingProfil71TypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil71TypeEnum = typeof RingProfil71TypeEnum[keyof typeof RingProfil71TypeEnum];

export interface RingProfil8 {
    'type'?: RingProfil8TypeEnum;
    'moldInner': number;
    'moldOuter': number;
    'radiusInner': number;
    'radiusOuter': number;
}

export const RingProfil8TypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil8TypeEnum = typeof RingProfil8TypeEnum[keyof typeof RingProfil8TypeEnum];

export interface RingProfil9 {
    'type'?: RingProfil9TypeEnum;
    'moldInner': Mold;
    'radiusInner': number;
    'radiusOuter': number;
}

export const RingProfil9TypeEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type RingProfil9TypeEnum = typeof RingProfil9TypeEnum[keyof typeof RingProfil9TypeEnum];

/**
 * @type RingSize
 */
export type RingSize = CustomWidth | Diameter | England | Switzerland | UsaCanada;

export interface RingStatus {
    'message'?: string;
    'Ring_ID'?: string;
    'Ring_Status_DE'?: string;
    'Ring_Status_EN'?: string;
    'Ring_Status_ID'?: string;
}
export interface RingWeight {
    'auShareWeight'?: number;
    'agShareWeight'?: number;
    'ptShareWeight'?: number;
    'pdShareWeight'?: number;
    'weight'?: number;
    'volume'?: number;
}
export interface RoundEdge {
    'type': RoundEdgeTypeEnum;
    'radius'?: number;
}

export const RoundEdgeTypeEnum = {
    Round: 'ROUND'
} as const;

export type RoundEdgeTypeEnum = typeof RoundEdgeTypeEnum[keyof typeof RoundEdgeTypeEnum];


export const SalesOrg = {
    HeimerleMeuleGmbh: 'HEIMERLE_MEULE_GMBH',
    HeimerleMeuleNlWien: 'HEIMERLE_MEULE_NL_WIEN',
    Sempsa: 'SEMPSA',
    Drijfhout: 'DRIJFHOUT',
    CooksonGold: 'COOKSON_GOLD',
    CooksonClal: 'COOKSON_CLAL'
} as const;

export type SalesOrg = typeof SalesOrg[keyof typeof SalesOrg];


export interface SapHealthStatus {
    'status'?: SapHealthStatusStatusEnum;
}

export const SapHealthStatusStatusEnum = {
    Up: 'UP',
    Down: 'DOWN'
} as const;

export type SapHealthStatusStatusEnum = typeof SapHealthStatusStatusEnum[keyof typeof SapHealthStatusStatusEnum];

export interface SapInvoiceDto {
    'docItemId'?: string;
    'type'?: string;
    'positions'?: Array<SapInvoicePositionDto>;
}
export interface SapInvoicePositionDto {
    'amount'?: string;
    'currency'?: string;
}
export interface SetCommissionNumberDto {
    'commissionNumber'?: string;
}
export interface SetNoteDto {
    'note'?: string;
}
export interface SettingsDTO {
    'minimumDeliverDays': number;
    'bannerDe'?: string;
    'bannerEn'?: string;
    'sliderImages'?: Array<SliderImage>;
    'maintenanceMode'?: boolean;
    'sliderSpeedMillis'?: number;
    'activeLanguages'?: Array<SettingsDTOActiveLanguagesEnum>;
}

export const SettingsDTOActiveLanguagesEnum = {
    En: 'EN',
    Fr: 'FR',
    De: 'DE',
    Es: 'ES',
    Sr: 'SR',
    Zh: 'ZH',
    Th: 'TH',
    Ko: 'KO',
    Ro: 'RO',
    Sl: 'SL',
    Hr: 'HR',
    Ms: 'MS',
    Uk: 'UK',
    Et: 'ET',
    Ar: 'AR',
    He: 'HE',
    Cz: 'CZ',
    El: 'EL',
    Hu: 'HU',
    It: 'IT',
    Ja: 'JA',
    Da: 'DA',
    Pl: 'PL',
    Zf: 'ZF',
    No: 'NO',
    Pt: 'PT',
    Sk: 'SK',
    Ru: 'RU',
    Tr: 'TR',
    Fi: 'FI',
    Sv: 'SV',
    Bg: 'BG',
    Lt: 'LT',
    Lv: 'LV',
    Z1: 'Z1',
    Af: 'AF',
    Is: 'IS',
    Ca: 'CA',
    Sh: 'SH',
    Id: 'ID',
    Nl: 'NL'
} as const;

export type SettingsDTOActiveLanguagesEnum = typeof SettingsDTOActiveLanguagesEnum[keyof typeof SettingsDTOActiveLanguagesEnum];

export interface ShippingDateDTO {
    'date'?: string;
    'selectable'?: boolean;
    'comment'?: string;
}
export interface ShoppingCartDTO {
    'shoppingCartItems'?: Array<ShoppingCartItemDTO>;
    'totalAmount'?: number;
    'totalMetalCost'?: number;
    'totalFormCost'?: number;
    'totalUnitCost'?: number;
    'commissionNumber'?: string;
    'note'?: string;
    'totalRingQuantity'?: number;
    'totalManufacturingCost'?: number;
    'totalManufacturingCostWithDiscount'?: number;
    'totalDiscount'?: number;
    'coupon'?: UserCouponDto;
}
/**
 * @type ShoppingCartItemDTO
 */
export type ShoppingCartItemDTO = PairShoppingCartItemDTO | SingleShoppingCartItemDTO;

export interface SimulationRequest {
    'userId': string;
    'items': Array<AddShoppingCartItemDTO>;
}
export interface SingleRing {
    'type': SingleRingTypeEnum;
    'ringConfig': RingConfig;
}

export const SingleRingTypeEnum = {
    SingleRing: 'SINGLE_RING'
} as const;

export type SingleRingTypeEnum = typeof SingleRingTypeEnum[keyof typeof SingleRingTypeEnum];

export interface SingleShoppingCartItemDTO {
    'id': string;
    'commissionNumber'?: string;
    'note'?: string;
    'priceCalculationError'?: boolean;
    'totalPrice': number;
    'itemWarnings': Array<ItemWarning>;
    'type': SingleShoppingCartItemDTOTypeEnum;
    'quantity'?: number;
    'ringPrice': RingPrice;
    'singleRing': SingleRing;
    'ringWeight'?: RingWeight;
    'favoriteName'?: string;
}

export const SingleShoppingCartItemDTOTypeEnum = {
    SingleItem: 'SINGLE_ITEM'
} as const;

export type SingleShoppingCartItemDTOTypeEnum = typeof SingleShoppingCartItemDTOTypeEnum[keyof typeof SingleShoppingCartItemDTOTypeEnum];

export interface SliderImage {
    'position'?: number;
    'active'?: boolean;
    'imageId': string;
}
export interface Subscribe {
    'email'?: string;
    'privacyPolicyAccepted'?: boolean;
    'hcaptchaPasscode': string;
}
export interface SubscribeToGoldzeitenDe {
    'subscribeToGoldzeitenDe'?: boolean;
}
export interface SubscribeToHeimerleMeule {
    'subscribeToHeimerleMeule'?: boolean;
}
export interface Subscription {
    'subscribeToHeimerleMeule'?: boolean;
    'subscribeToGoldzeitenDe'?: boolean;
}
export interface Switzerland {
    'type': SwitzerlandTypeEnum;
    'width': SwitzerlandWidthEnum;
}

export const SwitzerlandTypeEnum = {
    Switzerland: 'SWITZERLAND'
} as const;

export type SwitzerlandTypeEnum = typeof SwitzerlandTypeEnum[keyof typeof SwitzerlandTypeEnum];
export const SwitzerlandWidthEnum = {
    Swiss175: 'SWISS_1_75',
    Swiss225: 'SWISS_2_25',
    Swiss3: 'SWISS_3',
    Swiss35: 'SWISS_3_5',
    Swiss425: 'SWISS_4_25',
    Swiss475: 'SWISS_4_75',
    Swiss55: 'SWISS_5_5',
    Swiss6: 'SWISS_6',
    Swiss675: 'SWISS_6_75',
    Swiss75: 'SWISS_7_5',
    Swiss8: 'SWISS_8',
    Swiss875: 'SWISS_8_75',
    Swiss925: 'SWISS_9_25',
    Swiss10: 'SWISS_10',
    Swiss105: 'SWISS_10_5',
    Swiss1125: 'SWISS_11_25',
    Swiss1175: 'SWISS_11_75',
    Swiss125: 'SWISS_12_5',
    Swiss1325: 'SWISS_13_25',
    Swiss1375: 'SWISS_13_75',
    Swiss145: 'SWISS_14_5',
    Swiss15: 'SWISS_15',
    Swiss1575: 'SWISS_15_75',
    Swiss1625: 'SWISS_16_25',
    Swiss17: 'SWISS_17',
    Swiss1752: 'SWISS_17_5',
    Swiss1825: 'SWISS_18_25',
    Swiss19: 'SWISS_19',
    Swiss195: 'SWISS_19_5',
    Swiss2025: 'SWISS_20_25',
    Swiss2075: 'SWISS_20_75',
    Swiss215: 'SWISS_21_5',
    Swiss22: 'SWISS_22',
    Swiss2275: 'SWISS_22_75',
    Swiss2325: 'SWISS_23_25',
    Swiss24: 'SWISS_24',
    Swiss2475: 'SWISS_24_75',
    Swiss2525: 'SWISS_25_25',
    Swiss26: 'SWISS_26',
    Swiss265: 'SWISS_26_5',
    Swiss2725: 'SWISS_27_25',
    Swiss2775: 'SWISS_27_75',
    Swiss285: 'SWISS_28_5',
    Swiss29: 'SWISS_29',
    Swiss2975: 'SWISS_29_75',
    Swiss305: 'SWISS_30_5',
    Swiss31: 'SWISS_31',
    Swiss3175: 'SWISS_31_75',
    Swiss3225: 'SWISS_32_25',
    Swiss33: 'SWISS_33',
    Swiss335: 'SWISS_33_5',
    Swiss3425: 'SWISS_34_25'
} as const;

export type SwitzerlandWidthEnum = typeof SwitzerlandWidthEnum[keyof typeof SwitzerlandWidthEnum];

export interface TokenValidity {
    'invalid'?: boolean;
    'used'?: boolean;
    'expired'?: boolean;
}
export interface TubeConfig {
    'type': TubeConfigTypeEnum;
    'form': TubeConfigFormEnum;
    'priceCalculationType'?: TubeConfigPriceCalculationTypeEnum;
    'alloyId': string;
    'alloyDetails'?: AlloyDetails;
    'wallThicknessTolerance': number;
    'width': number;
    'wallThickness': number;
    'tubeSize': TubeSize;
    'volume'?: number;
    'alloyWeight'?: AlloyWeight;
}

export const TubeConfigTypeEnum = {
    AxialSintering: 'AXIAL_SINTERING',
    NormalSintering: 'NORMAL_SINTERING',
    Profil: 'PROFIL',
    Tube: 'TUBE'
} as const;

export type TubeConfigTypeEnum = typeof TubeConfigTypeEnum[keyof typeof TubeConfigTypeEnum];
export const TubeConfigFormEnum = {
    Form0: 'FORM_0',
    Form0C: 'FORM_0C',
    Form1: 'FORM_1',
    Form2: 'FORM_2',
    Form3: 'FORM_3',
    Form4: 'FORM_4',
    Form5: 'FORM_5',
    Form6: 'FORM_6',
    Form7: 'FORM_7',
    Form8: 'FORM_8',
    Form9: 'FORM_9',
    Form10: 'FORM_10',
    Form11: 'FORM_11',
    Form12: 'FORM_12',
    Form13: 'FORM_13',
    Form14: 'FORM_14',
    Form16: 'FORM_16',
    Form17: 'FORM_17',
    Form71: 'FORM_71'
} as const;

export type TubeConfigFormEnum = typeof TubeConfigFormEnum[keyof typeof TubeConfigFormEnum];
export const TubeConfigPriceCalculationTypeEnum = {
    ByWeight: 'BY_WEIGHT',
    ByQuantity: 'BY_QUANTITY',
    ByCustomerQuantity: 'BY_CUSTOMER_QUANTITY',
    ByTubeWeight: 'BY_TUBE_WEIGHT'
} as const;

export type TubeConfigPriceCalculationTypeEnum = typeof TubeConfigPriceCalculationTypeEnum[keyof typeof TubeConfigPriceCalculationTypeEnum];

export interface TubeDiameter {
    'type': TubeDiameterTypeEnum;
    'size': TubeDiameterSize;
}

export const TubeDiameterTypeEnum = {
    TubeDiameter: 'TUBE_DIAMETER'
} as const;

export type TubeDiameterTypeEnum = typeof TubeDiameterTypeEnum[keyof typeof TubeDiameterTypeEnum];

export interface TubeDiameterCustom {
    'type': TubeDiameterCustomTypeEnum;
    'size': number;
}

export const TubeDiameterCustomTypeEnum = {
    TubeDiameterCustom: 'TUBE_DIAMETER_CUSTOM'
} as const;

export type TubeDiameterCustomTypeEnum = typeof TubeDiameterCustomTypeEnum[keyof typeof TubeDiameterCustomTypeEnum];


export const TubeDiameterSize = {
    Diameter1464: 'DIAMETER_14_64',
    Diameter1496: 'DIAMETER_14_96',
    Diameter1528: 'DIAMETER_15_28',
    Diameter156: 'DIAMETER_15_6',
    Diameter1592: 'DIAMETER_15_92',
    Diameter1623: 'DIAMETER_16_23',
    Diameter1655: 'DIAMETER_16_55',
    Diameter1687: 'DIAMETER_16_87',
    Diameter1719: 'DIAMETER_17_19',
    Diameter1751: 'DIAMETER_17_51',
    Diameter1783: 'DIAMETER_17_83',
    Diameter1814: 'DIAMETER_18_14',
    Diameter1846: 'DIAMETER_18_46',
    Diameter1878: 'DIAMETER_18_78',
    Diameter191: 'DIAMETER_19_1',
    Diameter1942: 'DIAMETER_19_42',
    Diameter1974: 'DIAMETER_19_74',
    Diameter2005: 'DIAMETER_20_05',
    Diameter2037: 'DIAMETER_20_37',
    Diameter2069: 'DIAMETER_20_69',
    Diameter2101: 'DIAMETER_21_01',
    Diameter2133: 'DIAMETER_21_33',
    Diameter2165: 'DIAMETER_21_65',
    Diameter2196: 'DIAMETER_21_96',
    Diameter2228: 'DIAMETER_22_28',
    Diameter226: 'DIAMETER_22_6',
    Diameter2292: 'DIAMETER_22_92',
    Diameter2324: 'DIAMETER_23_24',
    Diameter2355: 'DIAMETER_23_55'
} as const;

export type TubeDiameterSize = typeof TubeDiameterSize[keyof typeof TubeDiameterSize];


export interface TubeMinOrderWeight {
    'type'?: TubeMinOrderWeightTypeEnum;
    'requiredWeight'?: number;
    'alloyId'?: string;
    'materialNumber'?: string;
}

export const TubeMinOrderWeightTypeEnum = {
    TubeMinOrderWeight: 'TUBE_MIN_ORDER_WEIGHT',
    PriceChange: 'PRICE_CHANGE'
} as const;

export type TubeMinOrderWeightTypeEnum = typeof TubeMinOrderWeightTypeEnum[keyof typeof TubeMinOrderWeightTypeEnum];

/**
 * @type TubeSize
 */
export type TubeSize = TubeDiameter | TubeDiameterCustom | TubeWidth | TubeWidthCustom;

export interface TubeWidth {
    'type': TubeWidthTypeEnum;
    'size': TubeWidthSize;
}

export const TubeWidthTypeEnum = {
    TubeWidth: 'TUBE_WIDTH'
} as const;

export type TubeWidthTypeEnum = typeof TubeWidthTypeEnum[keyof typeof TubeWidthTypeEnum];

export interface TubeWidthCustom {
    'type': TubeWidthCustomTypeEnum;
    'size': number;
}

export const TubeWidthCustomTypeEnum = {
    TubeWidthCustom: 'TUBE_WIDTH_CUSTOM'
} as const;

export type TubeWidthCustomTypeEnum = typeof TubeWidthCustomTypeEnum[keyof typeof TubeWidthCustomTypeEnum];


export const TubeWidthSize = {
    Size46: 'SIZE_46',
    Size47: 'SIZE_47',
    Size48: 'SIZE_48',
    Size49: 'SIZE_49',
    Size50: 'SIZE_50',
    Size51: 'SIZE_51',
    Size52: 'SIZE_52',
    Size53: 'SIZE_53',
    Size54: 'SIZE_54',
    Size55: 'SIZE_55',
    Size56: 'SIZE_56',
    Size57: 'SIZE_57',
    Size58: 'SIZE_58',
    Size59: 'SIZE_59',
    Size60: 'SIZE_60',
    Size61: 'SIZE_61',
    Size62: 'SIZE_62',
    Size63: 'SIZE_63',
    Size64: 'SIZE_64',
    Size65: 'SIZE_65',
    Size66: 'SIZE_66',
    Size67: 'SIZE_67',
    Size68: 'SIZE_68',
    Size69: 'SIZE_69',
    Size70: 'SIZE_70',
    Size71: 'SIZE_71',
    Size72: 'SIZE_72',
    Size73: 'SIZE_73',
    Size74: 'SIZE_74'
} as const;

export type TubeWidthSize = typeof TubeWidthSize[keyof typeof TubeWidthSize];


export interface TwoFaDto {
    'twoFaCode': string;
}
export interface UNut {
    'type'?: UNutTypeEnum;
    'position': number;
    'width': number;
    'depth': number;
    'depthFromTheTop': number;
}

export const UNutTypeEnum = {
    UNut: 'U_NUT'
} as const;

export type UNutTypeEnum = typeof UNutTypeEnum[keyof typeof UNutTypeEnum];

export interface UnitCost {
    'baseUnitCost': number;
    'totalUnitCost': number;
    'nutFee': number;
}
export interface UpdateCorrespondenceEmailsDto {
    'correspondenceEmails'?: Array<string>;
}
export interface UpdateFavoriteDTO {
    'name': string;
    'note'?: string;
}
export interface UpdateMetalAccountOrderPreferenceDTO {
    'metalAccountOrderPreference'?: UpdateMetalAccountOrderPreferenceDTOMetalAccountOrderPreferenceEnum;
}

export const UpdateMetalAccountOrderPreferenceDTOMetalAccountOrderPreferenceEnum = {
    AlwaysAsk: 'ALWAYS_ASK',
    DefaultWithMetalAccount: 'DEFAULT_WITH_METAL_ACCOUNT',
    DefaultWithoutMetalAccount: 'DEFAULT_WITHOUT_METAL_ACCOUNT'
} as const;

export type UpdateMetalAccountOrderPreferenceDTOMetalAccountOrderPreferenceEnum = typeof UpdateMetalAccountOrderPreferenceDTOMetalAccountOrderPreferenceEnum[keyof typeof UpdateMetalAccountOrderPreferenceDTOMetalAccountOrderPreferenceEnum];

export interface UsaCanada {
    'type': UsaCanadaTypeEnum;
    'width': UsaCanadaWidthEnum;
}

export const UsaCanadaTypeEnum = {
    UsaCanada: 'USA_CANADA'
} as const;

export type UsaCanadaTypeEnum = typeof UsaCanadaTypeEnum[keyof typeof UsaCanadaTypeEnum];
export const UsaCanadaWidthEnum = {
    UsaCanada2: 'USA_CANADA_2',
    UsaCanada214: 'USA_CANADA_2_1_4',
    UsaCanada212: 'USA_CANADA_2_1_2',
    UsaCanada234: 'USA_CANADA_2_3_4',
    UsaCanada3: 'USA_CANADA_3',
    UsaCanada314: 'USA_CANADA_3_1_4',
    UsaCanada312: 'USA_CANADA_3_1_2',
    UsaCanada334: 'USA_CANADA_3_3_4',
    UsaCanada4: 'USA_CANADA_4',
    UsaCanada414: 'USA_CANADA_4_1_4',
    UsaCanada412: 'USA_CANADA_4_1_2',
    UsaCanada434: 'USA_CANADA_4_3_4',
    UsaCanada5: 'USA_CANADA_5',
    UsaCanada514: 'USA_CANADA_5_1_4',
    UsaCanada512: 'USA_CANADA_5_1_2',
    UsaCanada534: 'USA_CANADA_5_3_4',
    UsaCanada6: 'USA_CANADA_6',
    UsaCanada614: 'USA_CANADA_6_1_4',
    UsaCanada612: 'USA_CANADA_6_1_2',
    UsaCanada634: 'USA_CANADA_6_3_4',
    UsaCanada7: 'USA_CANADA_7',
    UsaCanada714: 'USA_CANADA_7_1_4',
    UsaCanada712: 'USA_CANADA_7_1_2',
    UsaCanada734: 'USA_CANADA_7_3_4',
    UsaCanada8: 'USA_CANADA_8',
    UsaCanada814: 'USA_CANADA_8_1_4',
    UsaCanada812: 'USA_CANADA_8_1_2',
    UsaCanada834: 'USA_CANADA_8_3_4',
    UsaCanada9: 'USA_CANADA_9',
    UsaCanada914: 'USA_CANADA_9_1_4',
    UsaCanada912: 'USA_CANADA_9_1_2',
    UsaCanada934: 'USA_CANADA_9_3_4',
    UsaCanada10: 'USA_CANADA_10',
    UsaCanada1014: 'USA_CANADA_10_1_4',
    UsaCanada1012: 'USA_CANADA_10_1_2',
    UsaCanada1034: 'USA_CANADA_10_3_4',
    UsaCanada11: 'USA_CANADA_11',
    UsaCanada1114: 'USA_CANADA_11_1_4',
    UsaCanada1112: 'USA_CANADA_11_1_2',
    UsaCanada1134: 'USA_CANADA_11_3_4',
    UsaCanada12: 'USA_CANADA_12',
    UsaCanada1214: 'USA_CANADA_12_1_4',
    UsaCanada1212: 'USA_CANADA_12_1_2',
    UsaCanada1234: 'USA_CANADA_12_3_4',
    UsaCanada13: 'USA_CANADA_13',
    UsaCanada1314: 'USA_CANADA_13_1_4',
    UsaCanada1312: 'USA_CANADA_13_1_2',
    UsaCanada1334: 'USA_CANADA_13_3_4',
    UsaCanada14: 'USA_CANADA_14',
    UsaCanada1414: 'USA_CANADA_14_1_4',
    UsaCanada1412: 'USA_CANADA_14_1_2',
    UsaCanada1434: 'USA_CANADA_14_3_4',
    UsaCanada1512: 'USA_CANADA_15_1_2',
    UsaCanada1534: 'USA_CANADA_15_3_4',
    UsaCanada16: 'USA_CANADA_16'
} as const;

export type UsaCanadaWidthEnum = typeof UsaCanadaWidthEnum[keyof typeof UsaCanadaWidthEnum];

export interface UserAnimation {
    'animation'?: boolean;
}
export interface UserCouponDto {
    'code'?: string;
    'discount'?: number;
    'discountType'?: DiscountType;
}


export interface UserDTO {
    'id'?: string;
    'customerNumber'?: string;
    'email'?: string;
    'emailVerified'?: boolean;
    'showBulkImport'?: boolean;
    'showTubeConfig'?: boolean;
    'langKey'?: UserDTOLangKeyEnum;
    'docLangKey'?: UserDTODocLangKeyEnum;
    'displayPrices'?: boolean;
    'priceFactor'?: number;
    'masterData'?: MasterDataDTO;
    'verificationStatus'?: UserDTOVerificationStatusEnum;
    'email2FaActivated'?: boolean;
    'animation'?: boolean;
    'salesOrg'?: number;
    'showMetalAccount'?: boolean;
    'showSinteringConfig'?: boolean;
    'userModus'?: UserDTOUserModusEnum;
    'correspondenceEmails'?: Array<string>;
    'heimerleMeuleCustomer'?: UserDTOHeimerleMeuleCustomerEnum;
    'impersonated'?: boolean;
    'metalAccountOrderPreference'?: UserDTOMetalAccountOrderPreferenceEnum;
}

export const UserDTOLangKeyEnum = {
    En: 'EN',
    Fr: 'FR',
    De: 'DE',
    Es: 'ES',
    Sr: 'SR',
    Zh: 'ZH',
    Th: 'TH',
    Ko: 'KO',
    Ro: 'RO',
    Sl: 'SL',
    Hr: 'HR',
    Ms: 'MS',
    Uk: 'UK',
    Et: 'ET',
    Ar: 'AR',
    He: 'HE',
    Cz: 'CZ',
    El: 'EL',
    Hu: 'HU',
    It: 'IT',
    Ja: 'JA',
    Da: 'DA',
    Pl: 'PL',
    Zf: 'ZF',
    No: 'NO',
    Pt: 'PT',
    Sk: 'SK',
    Ru: 'RU',
    Tr: 'TR',
    Fi: 'FI',
    Sv: 'SV',
    Bg: 'BG',
    Lt: 'LT',
    Lv: 'LV',
    Z1: 'Z1',
    Af: 'AF',
    Is: 'IS',
    Ca: 'CA',
    Sh: 'SH',
    Id: 'ID',
    Nl: 'NL'
} as const;

export type UserDTOLangKeyEnum = typeof UserDTOLangKeyEnum[keyof typeof UserDTOLangKeyEnum];
export const UserDTODocLangKeyEnum = {
    En: 'EN',
    Fr: 'FR',
    De: 'DE',
    Es: 'ES',
    Sr: 'SR',
    Zh: 'ZH',
    Th: 'TH',
    Ko: 'KO',
    Ro: 'RO',
    Sl: 'SL',
    Hr: 'HR',
    Ms: 'MS',
    Uk: 'UK',
    Et: 'ET',
    Ar: 'AR',
    He: 'HE',
    Cz: 'CZ',
    El: 'EL',
    Hu: 'HU',
    It: 'IT',
    Ja: 'JA',
    Da: 'DA',
    Pl: 'PL',
    Zf: 'ZF',
    No: 'NO',
    Pt: 'PT',
    Sk: 'SK',
    Ru: 'RU',
    Tr: 'TR',
    Fi: 'FI',
    Sv: 'SV',
    Bg: 'BG',
    Lt: 'LT',
    Lv: 'LV',
    Z1: 'Z1',
    Af: 'AF',
    Is: 'IS',
    Ca: 'CA',
    Sh: 'SH',
    Id: 'ID',
    Nl: 'NL'
} as const;

export type UserDTODocLangKeyEnum = typeof UserDTODocLangKeyEnum[keyof typeof UserDTODocLangKeyEnum];
export const UserDTOVerificationStatusEnum = {
    InProgress: 'IN_PROGRESS',
    Verified: 'VERIFIED',
    Rejected: 'REJECTED'
} as const;

export type UserDTOVerificationStatusEnum = typeof UserDTOVerificationStatusEnum[keyof typeof UserDTOVerificationStatusEnum];
export const UserDTOUserModusEnum = {
    Normal: 'NORMAL',
    TestAccount: 'TEST_ACCOUNT',
    ServiceAccount: 'SERVICE_ACCOUNT'
} as const;

export type UserDTOUserModusEnum = typeof UserDTOUserModusEnum[keyof typeof UserDTOUserModusEnum];
export const UserDTOHeimerleMeuleCustomerEnum = {
    Yes: 'YES',
    No: 'NO'
} as const;

export type UserDTOHeimerleMeuleCustomerEnum = typeof UserDTOHeimerleMeuleCustomerEnum[keyof typeof UserDTOHeimerleMeuleCustomerEnum];
export const UserDTOMetalAccountOrderPreferenceEnum = {
    AlwaysAsk: 'ALWAYS_ASK',
    DefaultWithMetalAccount: 'DEFAULT_WITH_METAL_ACCOUNT',
    DefaultWithoutMetalAccount: 'DEFAULT_WITHOUT_METAL_ACCOUNT'
} as const;

export type UserDTOMetalAccountOrderPreferenceEnum = typeof UserDTOMetalAccountOrderPreferenceEnum[keyof typeof UserDTOMetalAccountOrderPreferenceEnum];

export interface UserDocumentDto {
    'user': UserDTO;
    'originalFilename': string;
    'content': string;
    'contentType': string;
    'size': number;
    'documentType': UserDocumentDtoDocumentTypeEnum;
    'sentToElo'?: boolean;
}

export const UserDocumentDtoDocumentTypeEnum = {
    Gewerbeanmeldung: 'GEWERBEANMELDUNG',
    Ausweis: 'AUSWEIS',
    Kundenstammblatt: 'KUNDENSTAMMBLATT',
    StammdatenAenderungsNachweis: 'STAMMDATEN_AENDERUNGS_NACHWEIS'
} as const;

export type UserDocumentDtoDocumentTypeEnum = typeof UserDocumentDtoDocumentTypeEnum[keyof typeof UserDocumentDtoDocumentTypeEnum];

export interface UserMetalAccountDTO {
    'message'?: string;
    'customerNumber'?: string;
    'auUnit'?: number;
    'agUnit'?: number;
    'ptUnit'?: number;
    'pdUnit'?: number;
}
export interface UserPricesDTO {
    'displayPrices': boolean;
    'priceFactor': number;
}
export interface VNut55 {
    'type'?: VNut55TypeEnum;
    'position': number;
    'width': number;
    'depth'?: number;
    'depthFromTheTop': number;
}

export const VNut55TypeEnum = {
    VNut55: 'V_NUT_55'
} as const;

export type VNut55TypeEnum = typeof VNut55TypeEnum[keyof typeof VNut55TypeEnum];


/**
 * ActuatorApi - axios parameter creator
 */
export const ActuatorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Actuator web endpoint \'health\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'info\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        info: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator root web endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        links: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'metrics\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNames: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'metrics-requiredMetricName\'
         * @param {string} requiredMetricName 
         * @param {string} [tag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metric: async (requiredMetricName: string, tag?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requiredMetricName' is not null or undefined
            assertParamExists('metric', 'requiredMetricName', requiredMetricName)
            const localVarPath = `/actuator/metrics/{requiredMetricName}`
                .replace(`{${"requiredMetricName"}}`, encodeURIComponent(String(requiredMetricName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tag !== undefined) {
                localVarQueryParameter['tag'] = tag;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Actuator web endpoint \'prometheus\'
         * @param {ScrapeFormatEnum} [format] 
         * @param {string} [includedNames] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scrape: async (format?: ScrapeFormatEnum, includedNames?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/actuator/prometheus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (includedNames !== undefined) {
                localVarQueryParameter['includedNames'] = includedNames;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActuatorApi - functional programming interface
 */
export const ActuatorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActuatorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Actuator web endpoint \'health\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async health(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.health(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActuatorApi.health']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Actuator web endpoint \'info\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async info(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.info(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActuatorApi.info']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Actuator root web endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async links(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: { [key: string]: Link; }; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.links(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActuatorApi.links']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Actuator web endpoint \'metrics\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNames(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNames(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActuatorApi.listNames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Actuator web endpoint \'metrics-requiredMetricName\'
         * @param {string} requiredMetricName 
         * @param {string} [tag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metric(requiredMetricName: string, tag?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metric(requiredMetricName, tag, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActuatorApi.metric']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Actuator web endpoint \'prometheus\'
         * @param {ScrapeFormatEnum} [format] 
         * @param {string} [includedNames] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scrape(format?: ScrapeFormatEnum, includedNames?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scrape(format, includedNames, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActuatorApi.scrape']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActuatorApi - factory interface
 */
export const ActuatorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActuatorApiFp(configuration)
    return {
        /**
         * 
         * @summary Actuator web endpoint \'health\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        health(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.health(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator web endpoint \'info\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        info(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.info(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator root web endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        links(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: { [key: string]: Link; }; }> {
            return localVarFp.links(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator web endpoint \'metrics\'
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNames(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.listNames(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator web endpoint \'metrics-requiredMetricName\'
         * @param {string} requiredMetricName 
         * @param {string} [tag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metric(requiredMetricName: string, tag?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.metric(requiredMetricName, tag, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Actuator web endpoint \'prometheus\'
         * @param {ScrapeFormatEnum} [format] 
         * @param {string} [includedNames] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scrape(format?: ScrapeFormatEnum, includedNames?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.scrape(format, includedNames, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActuatorApi - object-oriented interface
 */
export class ActuatorApi extends BaseAPI {
    /**
     * 
     * @summary Actuator web endpoint \'health\'
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public health(options?: RawAxiosRequestConfig) {
        return ActuatorApiFp(this.configuration).health(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator web endpoint \'info\'
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public info(options?: RawAxiosRequestConfig) {
        return ActuatorApiFp(this.configuration).info(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator root web endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public links(options?: RawAxiosRequestConfig) {
        return ActuatorApiFp(this.configuration).links(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator web endpoint \'metrics\'
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listNames(options?: RawAxiosRequestConfig) {
        return ActuatorApiFp(this.configuration).listNames(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator web endpoint \'metrics-requiredMetricName\'
     * @param {string} requiredMetricName 
     * @param {string} [tag] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public metric(requiredMetricName: string, tag?: string, options?: RawAxiosRequestConfig) {
        return ActuatorApiFp(this.configuration).metric(requiredMetricName, tag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Actuator web endpoint \'prometheus\'
     * @param {ScrapeFormatEnum} [format] 
     * @param {string} [includedNames] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public scrape(format?: ScrapeFormatEnum, includedNames?: string, options?: RawAxiosRequestConfig) {
        return ActuatorApiFp(this.configuration).scrape(format, includedNames, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ScrapeFormatEnum = {
    ContentType004: 'CONTENT_TYPE_004',
    ContentTypeOpenmetrics100: 'CONTENT_TYPE_OPENMETRICS_100',
    ContentTypeProtobuf: 'CONTENT_TYPE_PROTOBUF'
} as const;
export type ScrapeFormatEnum = typeof ScrapeFormatEnum[keyof typeof ScrapeFormatEnum];


/**
 * AddressControllerApi - axios parameter creator
 */
export const AddressControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ConfirmAddressDto} confirmAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmAddress: async (confirmAddressDto: ConfirmAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'confirmAddressDto' is not null or undefined
            assertParamExists('confirmAddress', 'confirmAddressDto', confirmAddressDto)
            const localVarPath = `/protected/addresses/confirm-address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddressDTO} addressDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewAddress: async (addressDTO: AddressDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressDTO' is not null or undefined
            assertParamExists('createNewAddress', 'addressDTO', addressDTO)
            const localVarPath = `/protected/addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addressDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddress: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAddress', 'id', id)
            const localVarPath = `/protected/addresses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyAddresses: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/addresses/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefault: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setDefault', 'id', id)
            const localVarPath = `/protected/addresses/set-default/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddressControllerApi - functional programming interface
 */
export const AddressControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddressControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ConfirmAddressDto} confirmAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmAddress(confirmAddressDto: ConfirmAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmAddressResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmAddress(confirmAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddressControllerApi.confirmAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AddressDTO} addressDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNewAddress(addressDTO: AddressDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNewAddress(addressDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddressControllerApi.createNewAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAddress(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAddress(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddressControllerApi.deleteAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyAddresses(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AddressDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyAddresses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddressControllerApi.getMyAddresses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDefault(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDefault(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddressControllerApi.setDefault']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AddressControllerApi - factory interface
 */
export const AddressControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddressControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ConfirmAddressDto} confirmAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmAddress(confirmAddressDto: ConfirmAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<ConfirmAddressResultDto> {
            return localVarFp.confirmAddress(confirmAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddressDTO} addressDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewAddress(addressDTO: AddressDTO, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createNewAddress(addressDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAddress(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAddress(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyAddresses(options?: RawAxiosRequestConfig): AxiosPromise<Array<AddressDTO>> {
            return localVarFp.getMyAddresses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefault(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setDefault(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AddressControllerApi - object-oriented interface
 */
export class AddressControllerApi extends BaseAPI {
    /**
     * 
     * @param {ConfirmAddressDto} confirmAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public confirmAddress(confirmAddressDto: ConfirmAddressDto, options?: RawAxiosRequestConfig) {
        return AddressControllerApiFp(this.configuration).confirmAddress(confirmAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddressDTO} addressDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createNewAddress(addressDTO: AddressDTO, options?: RawAxiosRequestConfig) {
        return AddressControllerApiFp(this.configuration).createNewAddress(addressDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAddress(id: string, options?: RawAxiosRequestConfig) {
        return AddressControllerApiFp(this.configuration).deleteAddress(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMyAddresses(options?: RawAxiosRequestConfig) {
        return AddressControllerApiFp(this.configuration).getMyAddresses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setDefault(id: string, options?: RawAxiosRequestConfig) {
        return AddressControllerApiFp(this.configuration).setDefault(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AlloyControllerApi - axios parameter creator
 */
export const AlloyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDefaultWithUserSpecific: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/alloys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlloy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAlloy', 'id', id)
            const localVarPath = `/public/alloys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AlloyControllerApi - functional programming interface
 */
export const AlloyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AlloyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDefaultWithUserSpecific(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AlloyDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDefaultWithUserSpecific(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlloyControllerApi.getAllDefaultWithUserSpecific']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlloy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlloyDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlloy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AlloyControllerApi.getAlloy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AlloyControllerApi - factory interface
 */
export const AlloyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AlloyControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDefaultWithUserSpecific(options?: RawAxiosRequestConfig): AxiosPromise<Array<AlloyDTO>> {
            return localVarFp.getAllDefaultWithUserSpecific(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlloy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AlloyDTO> {
            return localVarFp.getAlloy(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AlloyControllerApi - object-oriented interface
 */
export class AlloyControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllDefaultWithUserSpecific(options?: RawAxiosRequestConfig) {
        return AlloyControllerApiFp(this.configuration).getAllDefaultWithUserSpecific(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAlloy(id: string, options?: RawAxiosRequestConfig) {
        return AlloyControllerApiFp(this.configuration).getAlloy(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CalculationControllerApi - axios parameter creator
 */
export const CalculationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CalculateRequest} calculateRequest 
         * @param {number} [quantity1] 
         * @param {number} [quantity2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculate: async (calculateRequest: CalculateRequest, quantity1?: number, quantity2?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculateRequest' is not null or undefined
            assertParamExists('calculate', 'calculateRequest', calculateRequest)
            const localVarPath = `/protected/user/calculation/price`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (quantity1 !== undefined) {
                localVarQueryParameter['quantity1'] = quantity1;
            }

            if (quantity2 !== undefined) {
                localVarQueryParameter['quantity2'] = quantity2;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calculateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculationControllerApi - functional programming interface
 */
export const CalculationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalculationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CalculateRequest} calculateRequest 
         * @param {number} [quantity1] 
         * @param {number} [quantity2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculate(calculateRequest: CalculateRequest, quantity1?: number, quantity2?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalcResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculate(calculateRequest, quantity1, quantity2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationControllerApi.calculate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalculationControllerApi - factory interface
 */
export const CalculationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalculationControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {CalculateRequest} calculateRequest 
         * @param {number} [quantity1] 
         * @param {number} [quantity2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculate(calculateRequest: CalculateRequest, quantity1?: number, quantity2?: number, options?: RawAxiosRequestConfig): AxiosPromise<CalcResponse> {
            return localVarFp.calculate(calculateRequest, quantity1, quantity2, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalculationControllerApi - object-oriented interface
 */
export class CalculationControllerApi extends BaseAPI {
    /**
     * 
     * @param {CalculateRequest} calculateRequest 
     * @param {number} [quantity1] 
     * @param {number} [quantity2] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public calculate(calculateRequest: CalculateRequest, quantity1?: number, quantity2?: number, options?: RawAxiosRequestConfig) {
        return CalculationControllerApiFp(this.configuration).calculate(calculateRequest, quantity1, quantity2, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DownloadControllerApi - axios parameter creator
 */
export const DownloadControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} ott 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadRingoPdf: async (ott: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ott' is not null or undefined
            assertParamExists('downloadRingoPdf', 'ott', ott)
            const localVarPath = `/public/download/ringo-pdf/{ott}.pdf`
                .replace(`{${"ott"}}`, encodeURIComponent(String(ott)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ott 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSapPdf: async (ott: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ott' is not null or undefined
            assertParamExists('downloadSapPdf', 'ott', ott)
            const localVarPath = `/public/download/sap-pdf/{ott}.pdf`
                .replace(`{${"ott"}}`, encodeURIComponent(String(ott)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DownloadControllerApi - functional programming interface
 */
export const DownloadControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DownloadControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} ott 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadRingoPdf(ott: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadRingoPdf(ott, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DownloadControllerApi.downloadRingoPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} ott 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSapPdf(ott: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSapPdf(ott, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DownloadControllerApi.downloadSapPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DownloadControllerApi - factory interface
 */
export const DownloadControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DownloadControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} ott 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadRingoPdf(ott: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadRingoPdf(ott, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} ott 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSapPdf(ott: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSapPdf(ott, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DownloadControllerApi - object-oriented interface
 */
export class DownloadControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} ott 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadRingoPdf(ott: string, options?: RawAxiosRequestConfig) {
        return DownloadControllerApiFp(this.configuration).downloadRingoPdf(ott, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} ott 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadSapPdf(ott: string, options?: RawAxiosRequestConfig) {
        return DownloadControllerApiFp(this.configuration).downloadSapPdf(ott, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FavoriteControllerApi - axios parameter creator
 */
export const FavoriteControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoritePosition: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteFavoritePosition', 'id', id)
            const localVarPath = `/protected/favorite/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsByName: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('existsByName', 'name', name)
            const localVarPath = `/protected/favorite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {Array<FilterFavoritePositionsRingConfigTypesEnum>} [ringConfigTypes] 
         * @param {Array<string>} [names] 
         * @param {string} [userId] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterFavoritePositions: async (filter?: string, ringConfigTypes?: Array<FilterFavoritePositionsRingConfigTypesEnum>, names?: Array<string>, userId?: string, page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/favorite/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (ringConfigTypes) {
                localVarQueryParameter['ringConfigTypes'] = ringConfigTypes;
            }

            if (names) {
                localVarQueryParameter['names'] = names;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoritePosition: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFavoritePosition', 'id', id)
            const localVarPath = `/protected/favorite/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoritePosition1: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getFavoritePosition1', 'name', name)
            const localVarPath = `/protected/favorite/existByName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FavoriteDTO} favoriteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFavorite: async (favoriteDTO: FavoriteDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'favoriteDTO' is not null or undefined
            assertParamExists('saveFavorite', 'favoriteDTO', favoriteDTO)
            const localVarPath = `/protected/favorite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(favoriteDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateFavoriteDTO} updateFavoriteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFavorite: async (id: string, updateFavoriteDTO: UpdateFavoriteDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateFavorite', 'id', id)
            // verify required parameter 'updateFavoriteDTO' is not null or undefined
            assertParamExists('updateFavorite', 'updateFavoriteDTO', updateFavoriteDTO)
            const localVarPath = `/protected/favorite/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFavoriteDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FavoriteControllerApi - functional programming interface
 */
export const FavoriteControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FavoriteControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFavoritePosition(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFavoritePosition(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FavoriteControllerApi.deleteFavoritePosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async existsByName(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.existsByName(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FavoriteControllerApi.existsByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {Array<FilterFavoritePositionsRingConfigTypesEnum>} [ringConfigTypes] 
         * @param {Array<string>} [names] 
         * @param {string} [userId] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filterFavoritePositions(filter?: string, ringConfigTypes?: Array<FilterFavoritePositionsRingConfigTypesEnum>, names?: Array<string>, userId?: string, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestPageFavoriteDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filterFavoritePositions(filter, ringConfigTypes, names, userId, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FavoriteControllerApi.filterFavoritePositions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavoritePosition(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FavoriteDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFavoritePosition(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FavoriteControllerApi.getFavoritePosition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFavoritePosition1(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFavoritePosition1(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FavoriteControllerApi.getFavoritePosition1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FavoriteDTO} favoriteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveFavorite(favoriteDTO: FavoriteDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FavoriteDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveFavorite(favoriteDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FavoriteControllerApi.saveFavorite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateFavoriteDTO} updateFavoriteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFavorite(id: string, updateFavoriteDTO: UpdateFavoriteDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFavorite(id, updateFavoriteDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FavoriteControllerApi.updateFavorite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FavoriteControllerApi - factory interface
 */
export const FavoriteControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FavoriteControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoritePosition(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFavoritePosition(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        existsByName(name: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.existsByName(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [filter] 
         * @param {Array<FilterFavoritePositionsRingConfigTypesEnum>} [ringConfigTypes] 
         * @param {Array<string>} [names] 
         * @param {string} [userId] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterFavoritePositions(filter?: string, ringConfigTypes?: Array<FilterFavoritePositionsRingConfigTypesEnum>, names?: Array<string>, userId?: string, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<RestPageFavoriteDTO> {
            return localVarFp.filterFavoritePositions(filter, ringConfigTypes, names, userId, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoritePosition(id: string, options?: RawAxiosRequestConfig): AxiosPromise<FavoriteDTO> {
            return localVarFp.getFavoritePosition(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFavoritePosition1(name: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.getFavoritePosition1(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FavoriteDTO} favoriteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFavorite(favoriteDTO: FavoriteDTO, options?: RawAxiosRequestConfig): AxiosPromise<FavoriteDTO> {
            return localVarFp.saveFavorite(favoriteDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateFavoriteDTO} updateFavoriteDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFavorite(id: string, updateFavoriteDTO: UpdateFavoriteDTO, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateFavorite(id, updateFavoriteDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FavoriteControllerApi - object-oriented interface
 */
export class FavoriteControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteFavoritePosition(id: string, options?: RawAxiosRequestConfig) {
        return FavoriteControllerApiFp(this.configuration).deleteFavoritePosition(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public existsByName(name: string, options?: RawAxiosRequestConfig) {
        return FavoriteControllerApiFp(this.configuration).existsByName(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [filter] 
     * @param {Array<FilterFavoritePositionsRingConfigTypesEnum>} [ringConfigTypes] 
     * @param {Array<string>} [names] 
     * @param {string} [userId] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filterFavoritePositions(filter?: string, ringConfigTypes?: Array<FilterFavoritePositionsRingConfigTypesEnum>, names?: Array<string>, userId?: string, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig) {
        return FavoriteControllerApiFp(this.configuration).filterFavoritePositions(filter, ringConfigTypes, names, userId, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFavoritePosition(id: string, options?: RawAxiosRequestConfig) {
        return FavoriteControllerApiFp(this.configuration).getFavoritePosition(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFavoritePosition1(name: string, options?: RawAxiosRequestConfig) {
        return FavoriteControllerApiFp(this.configuration).getFavoritePosition1(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FavoriteDTO} favoriteDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public saveFavorite(favoriteDTO: FavoriteDTO, options?: RawAxiosRequestConfig) {
        return FavoriteControllerApiFp(this.configuration).saveFavorite(favoriteDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateFavoriteDTO} updateFavoriteDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateFavorite(id: string, updateFavoriteDTO: UpdateFavoriteDTO, options?: RawAxiosRequestConfig) {
        return FavoriteControllerApiFp(this.configuration).updateFavorite(id, updateFavoriteDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

export const FilterFavoritePositionsRingConfigTypesEnum = {
    AxialSintering: 'AXIAL_SINTERING',
    NormalSintering: 'NORMAL_SINTERING',
    Profil: 'PROFIL',
    Tube: 'TUBE'
} as const;
export type FilterFavoritePositionsRingConfigTypesEnum = typeof FilterFavoritePositionsRingConfigTypesEnum[keyof typeof FilterFavoritePositionsRingConfigTypesEnum];


/**
 * FileControllerApi - axios parameter creator
 */
export const FileControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('_delete', 'fileId', fileId)
            const localVarPath = `/protected/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFile: async (fileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('getFile', 'fileId', fileId)
            const localVarPath = `/protected/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UploadDocumentTypeEnum} documentType 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: async (documentType: UploadDocumentTypeEnum, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('upload', 'documentType', documentType)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('upload', 'file', file)
            const localVarPath = `/protected/files/{documentType}`
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFiles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/files/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileControllerApi - functional programming interface
 */
export const FileControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileControllerApi._delete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFile(fileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFile(fileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileControllerApi.getFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UploadDocumentTypeEnum} documentType 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upload(documentType: UploadDocumentTypeEnum, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upload(documentType, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileControllerApi.upload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFiles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FileDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFiles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileControllerApi.userFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FileControllerApi - factory interface
 */
export const FileControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp._delete(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFile(fileId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserDocumentDto> {
            return localVarFp.getFile(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UploadDocumentTypeEnum} documentType 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(documentType: UploadDocumentTypeEnum, file: File, options?: RawAxiosRequestConfig): AxiosPromise<UserDocumentDto> {
            return localVarFp.upload(documentType, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFiles(options?: RawAxiosRequestConfig): AxiosPromise<Array<FileDTO>> {
            return localVarFp.userFiles(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileControllerApi - object-oriented interface
 */
export class FileControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public _delete(fileId: string, options?: RawAxiosRequestConfig) {
        return FileControllerApiFp(this.configuration)._delete(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getFile(fileId: string, options?: RawAxiosRequestConfig) {
        return FileControllerApiFp(this.configuration).getFile(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UploadDocumentTypeEnum} documentType 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public upload(documentType: UploadDocumentTypeEnum, file: File, options?: RawAxiosRequestConfig) {
        return FileControllerApiFp(this.configuration).upload(documentType, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userFiles(options?: RawAxiosRequestConfig) {
        return FileControllerApiFp(this.configuration).userFiles(options).then((request) => request(this.axios, this.basePath));
    }
}

export const UploadDocumentTypeEnum = {
    Gewerbeanmeldung: 'GEWERBEANMELDUNG',
    Ausweis: 'AUSWEIS',
    Kundenstammblatt: 'KUNDENSTAMMBLATT',
    StammdatenAenderungsNachweis: 'STAMMDATEN_AENDERUNGS_NACHWEIS'
} as const;
export type UploadDocumentTypeEnum = typeof UploadDocumentTypeEnum[keyof typeof UploadDocumentTypeEnum];


/**
 * IamControllerApi - axios parameter creator
 */
export const IamControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (changePasswordDto: ChangePasswordDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePasswordDto' is not null or undefined
            assertParamExists('changePassword', 'changePasswordDto', changePasswordDto)
            const localVarPath = `/protected/user/change-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmailTokenDto} emailTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmail: async (emailTokenDto: EmailTokenDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailTokenDto' is not null or undefined
            assertParamExists('confirmEmail', 'emailTokenDto', emailTokenDto)
            const localVarPath = `/public/confirm-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TwoFaDto} twoFaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disable2FaEmail: async (twoFaDto: TwoFaDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'twoFaDto' is not null or undefined
            assertParamExists('disable2FaEmail', 'twoFaDto', twoFaDto)
            const localVarPath = `/protected/user/disable-2fa-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(twoFaDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TwoFaDto} twoFaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enable2FaEmail: async (twoFaDto: TwoFaDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'twoFaDto' is not null or undefined
            assertParamExists('enable2FaEmail', 'twoFaDto', twoFaDto)
            const localVarPath = `/protected/user/enable-2fa-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(twoFaDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ForgotPasswordFinishDto} forgotPasswordFinishDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPasswordFinish: async (forgotPasswordFinishDto: ForgotPasswordFinishDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'forgotPasswordFinishDto' is not null or undefined
            assertParamExists('forgotPasswordFinish', 'forgotPasswordFinishDto', forgotPasswordFinishDto)
            const localVarPath = `/public/forgot-password/finish`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forgotPasswordFinishDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ForgotPasswordInitDto} forgotPasswordInitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPasswordInit: async (forgotPasswordInitDto: ForgotPasswordInitDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'forgotPasswordInitDto' is not null or undefined
            assertParamExists('forgotPasswordInit', 'forgotPasswordInitDto', forgotPasswordInitDto)
            const localVarPath = `/public/forgot-password/init`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forgotPasswordInitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initDisable2FaEmail: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/user/init-disable-2fa-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initEnable2FaEmail: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/user/init-enable-2fa-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckToken} checkToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isTokenValid: async (checkToken: CheckToken, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkToken' is not null or undefined
            assertParamExists('isTokenValid', 'checkToken', checkToken)
            const localVarPath = `/public/token/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkToken, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginDto: LoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginDto' is not null or undefined
            assertParamExists('login', 'loginDto', loginDto)
            const localVarPath = `/public/user/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Login2FA} login2FA 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login2Fa: async (login2FA: Login2FA, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'login2FA' is not null or undefined
            assertParamExists('login2Fa', 'login2FA', login2FA)
            const localVarPath = `/public/user/login-2fa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(login2FA, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterDTO} registerDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (registerDTO: RegisterDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerDTO' is not null or undefined
            assertParamExists('register', 'registerDTO', registerDTO)
            const localVarPath = `/public/users/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Resend2FaPublic} resend2FaPublic 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resend2FaCode: async (resend2FaPublic: Resend2FaPublic, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resend2FaPublic' is not null or undefined
            assertParamExists('resend2FaCode', 'resend2FaPublic', resend2FaPublic)
            const localVarPath = `/public/user/resend-2fa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resend2FaPublic, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resend2FaEmail: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/user/resend-2fa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendEmailVerification: async (loginDto: LoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginDto' is not null or undefined
            assertParamExists('resendEmailVerification', 'loginDto', loginDto)
            const localVarPath = `/public/user/resend-verification-email-by-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmailTokenDto} emailTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendEmailVerificationByOldToken: async (emailTokenDto: EmailTokenDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailTokenDto' is not null or undefined
            assertParamExists('resendEmailVerificationByOldToken', 'emailTokenDto', emailTokenDto)
            const localVarPath = `/public/user/resend-verification-email-by-old-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IamControllerApi - functional programming interface
 */
export const IamControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IamControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(changePasswordDto: ChangePasswordDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(changePasswordDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IamControllerApi.changePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EmailTokenDto} emailTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmEmail(emailTokenDto: EmailTokenDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfirmEmailResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmEmail(emailTokenDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IamControllerApi.confirmEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TwoFaDto} twoFaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disable2FaEmail(twoFaDto: TwoFaDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disable2FaEmail(twoFaDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IamControllerApi.disable2FaEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TwoFaDto} twoFaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enable2FaEmail(twoFaDto: TwoFaDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enable2FaEmail(twoFaDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IamControllerApi.enable2FaEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ForgotPasswordFinishDto} forgotPasswordFinishDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPasswordFinish(forgotPasswordFinishDto: ForgotPasswordFinishDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPasswordFinish(forgotPasswordFinishDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IamControllerApi.forgotPasswordFinish']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ForgotPasswordInitDto} forgotPasswordInitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPasswordInit(forgotPasswordInitDto: ForgotPasswordInitDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPasswordInit(forgotPasswordInitDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IamControllerApi.forgotPasswordInit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initDisable2FaEmail(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initDisable2FaEmail(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IamControllerApi.initDisable2FaEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initEnable2FaEmail(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initEnable2FaEmail(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IamControllerApi.initEnable2FaEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CheckToken} checkToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isTokenValid(checkToken: CheckToken, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenValidity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isTokenValid(checkToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IamControllerApi.isTokenValid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginDto: LoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JWTToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IamControllerApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Login2FA} login2FA 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login2Fa(login2FA: Login2FA, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JWTToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login2Fa(login2FA, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IamControllerApi.login2Fa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RegisterDTO} registerDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(registerDTO: RegisterDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(registerDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IamControllerApi.register']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Resend2FaPublic} resend2FaPublic 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resend2FaCode(resend2FaPublic: Resend2FaPublic, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resend2FaCode(resend2FaPublic, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IamControllerApi.resend2FaCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resend2FaEmail(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resend2FaEmail(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IamControllerApi.resend2FaEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendEmailVerification(loginDto: LoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendEmailVerification(loginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IamControllerApi.resendEmailVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EmailTokenDto} emailTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendEmailVerificationByOldToken(emailTokenDto: EmailTokenDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendEmailVerificationByOldToken(emailTokenDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IamControllerApi.resendEmailVerificationByOldToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IamControllerApi - factory interface
 */
export const IamControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IamControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ChangePasswordDto} changePasswordDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(changePasswordDto: ChangePasswordDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.changePassword(changePasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmailTokenDto} emailTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmail(emailTokenDto: EmailTokenDto, options?: RawAxiosRequestConfig): AxiosPromise<ConfirmEmailResultDto> {
            return localVarFp.confirmEmail(emailTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TwoFaDto} twoFaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disable2FaEmail(twoFaDto: TwoFaDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.disable2FaEmail(twoFaDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TwoFaDto} twoFaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enable2FaEmail(twoFaDto: TwoFaDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.enable2FaEmail(twoFaDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ForgotPasswordFinishDto} forgotPasswordFinishDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPasswordFinish(forgotPasswordFinishDto: ForgotPasswordFinishDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.forgotPasswordFinish(forgotPasswordFinishDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ForgotPasswordInitDto} forgotPasswordInitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPasswordInit(forgotPasswordInitDto: ForgotPasswordInitDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.forgotPasswordInit(forgotPasswordInitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initDisable2FaEmail(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.initDisable2FaEmail(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initEnable2FaEmail(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.initEnable2FaEmail(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckToken} checkToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isTokenValid(checkToken: CheckToken, options?: RawAxiosRequestConfig): AxiosPromise<TokenValidity> {
            return localVarFp.isTokenValid(checkToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginDto: LoginDto, options?: RawAxiosRequestConfig): AxiosPromise<JWTToken> {
            return localVarFp.login(loginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Login2FA} login2FA 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login2Fa(login2FA: Login2FA, options?: RawAxiosRequestConfig): AxiosPromise<JWTToken> {
            return localVarFp.login2Fa(login2FA, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegisterDTO} registerDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(registerDTO: RegisterDTO, options?: RawAxiosRequestConfig): AxiosPromise<UserDTO> {
            return localVarFp.register(registerDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Resend2FaPublic} resend2FaPublic 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resend2FaCode(resend2FaPublic: Resend2FaPublic, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resend2FaCode(resend2FaPublic, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resend2FaEmail(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resend2FaEmail(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendEmailVerification(loginDto: LoginDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resendEmailVerification(loginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EmailTokenDto} emailTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendEmailVerificationByOldToken(emailTokenDto: EmailTokenDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resendEmailVerificationByOldToken(emailTokenDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IamControllerApi - object-oriented interface
 */
export class IamControllerApi extends BaseAPI {
    /**
     * 
     * @param {ChangePasswordDto} changePasswordDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public changePassword(changePasswordDto: ChangePasswordDto, options?: RawAxiosRequestConfig) {
        return IamControllerApiFp(this.configuration).changePassword(changePasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmailTokenDto} emailTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public confirmEmail(emailTokenDto: EmailTokenDto, options?: RawAxiosRequestConfig) {
        return IamControllerApiFp(this.configuration).confirmEmail(emailTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TwoFaDto} twoFaDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public disable2FaEmail(twoFaDto: TwoFaDto, options?: RawAxiosRequestConfig) {
        return IamControllerApiFp(this.configuration).disable2FaEmail(twoFaDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TwoFaDto} twoFaDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public enable2FaEmail(twoFaDto: TwoFaDto, options?: RawAxiosRequestConfig) {
        return IamControllerApiFp(this.configuration).enable2FaEmail(twoFaDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ForgotPasswordFinishDto} forgotPasswordFinishDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public forgotPasswordFinish(forgotPasswordFinishDto: ForgotPasswordFinishDto, options?: RawAxiosRequestConfig) {
        return IamControllerApiFp(this.configuration).forgotPasswordFinish(forgotPasswordFinishDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ForgotPasswordInitDto} forgotPasswordInitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public forgotPasswordInit(forgotPasswordInitDto: ForgotPasswordInitDto, options?: RawAxiosRequestConfig) {
        return IamControllerApiFp(this.configuration).forgotPasswordInit(forgotPasswordInitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public initDisable2FaEmail(options?: RawAxiosRequestConfig) {
        return IamControllerApiFp(this.configuration).initDisable2FaEmail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public initEnable2FaEmail(options?: RawAxiosRequestConfig) {
        return IamControllerApiFp(this.configuration).initEnable2FaEmail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckToken} checkToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public isTokenValid(checkToken: CheckToken, options?: RawAxiosRequestConfig) {
        return IamControllerApiFp(this.configuration).isTokenValid(checkToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoginDto} loginDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public login(loginDto: LoginDto, options?: RawAxiosRequestConfig) {
        return IamControllerApiFp(this.configuration).login(loginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Login2FA} login2FA 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public login2Fa(login2FA: Login2FA, options?: RawAxiosRequestConfig) {
        return IamControllerApiFp(this.configuration).login2Fa(login2FA, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegisterDTO} registerDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public register(registerDTO: RegisterDTO, options?: RawAxiosRequestConfig) {
        return IamControllerApiFp(this.configuration).register(registerDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Resend2FaPublic} resend2FaPublic 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resend2FaCode(resend2FaPublic: Resend2FaPublic, options?: RawAxiosRequestConfig) {
        return IamControllerApiFp(this.configuration).resend2FaCode(resend2FaPublic, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resend2FaEmail(options?: RawAxiosRequestConfig) {
        return IamControllerApiFp(this.configuration).resend2FaEmail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoginDto} loginDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resendEmailVerification(loginDto: LoginDto, options?: RawAxiosRequestConfig) {
        return IamControllerApiFp(this.configuration).resendEmailVerification(loginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EmailTokenDto} emailTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resendEmailVerificationByOldToken(emailTokenDto: EmailTokenDto, options?: RawAxiosRequestConfig) {
        return IamControllerApiFp(this.configuration).resendEmailVerificationByOldToken(emailTokenDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InfoControllerApi - axios parameter creator
 */
export const InfoControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildProperties: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InfoControllerApi - functional programming interface
 */
export const InfoControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InfoControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async buildProperties(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildProperties>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.buildProperties(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InfoControllerApi.buildProperties']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InfoControllerApi - factory interface
 */
export const InfoControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InfoControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        buildProperties(options?: RawAxiosRequestConfig): AxiosPromise<BuildProperties> {
            return localVarFp.buildProperties(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InfoControllerApi - object-oriented interface
 */
export class InfoControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public buildProperties(options?: RawAxiosRequestConfig) {
        return InfoControllerApiFp(this.configuration).buildProperties(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MasterDataControllerApi - axios parameter creator
 */
export const MasterDataControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {File} file 
         * @param {string} masterDataDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMasterDataApproval: async (file: File, masterDataDTO: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('createMasterDataApproval', 'file', file)
            // verify required parameter 'masterDataDTO' is not null or undefined
            assertParamExists('createMasterDataApproval', 'masterDataDTO', masterDataDTO)
            const localVarPath = `/protected/master-data/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (masterDataDTO !== undefined) { 
                localVarFormParams.append('masterDataDTO', masterDataDTO as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMasterData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/master-data/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterDataControllerApi - functional programming interface
 */
export const MasterDataControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterDataControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {File} file 
         * @param {string} masterDataDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMasterDataApproval(file: File, masterDataDTO: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMasterDataApproval(file, masterDataDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MasterDataControllerApi.createMasterDataApproval']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMasterData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MasterDataResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllMasterData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MasterDataControllerApi.getAllMasterData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MasterDataControllerApi - factory interface
 */
export const MasterDataControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterDataControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {File} file 
         * @param {string} masterDataDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMasterDataApproval(file: File, masterDataDTO: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createMasterDataApproval(file, masterDataDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMasterData(options?: RawAxiosRequestConfig): AxiosPromise<MasterDataResponseDto> {
            return localVarFp.getAllMasterData(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MasterDataControllerApi - object-oriented interface
 */
export class MasterDataControllerApi extends BaseAPI {
    /**
     * 
     * @param {File} file 
     * @param {string} masterDataDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createMasterDataApproval(file: File, masterDataDTO: string, options?: RawAxiosRequestConfig) {
        return MasterDataControllerApiFp(this.configuration).createMasterDataApproval(file, masterDataDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllMasterData(options?: RawAxiosRequestConfig) {
        return MasterDataControllerApiFp(this.configuration).getAllMasterData(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MetalAccountControllerApi - axios parameter creator
 */
export const MetalAccountControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetalAccount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/metal-account/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetalAccountControllerApi - functional programming interface
 */
export const MetalAccountControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetalAccountControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMetalAccount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMetalAccountDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMetalAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetalAccountControllerApi.getMetalAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MetalAccountControllerApi - factory interface
 */
export const MetalAccountControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetalAccountControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetalAccount(options?: RawAxiosRequestConfig): AxiosPromise<UserMetalAccountDTO> {
            return localVarFp.getMetalAccount(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetalAccountControllerApi - object-oriented interface
 */
export class MetalAccountControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMetalAccount(options?: RawAxiosRequestConfig) {
        return MetalAccountControllerApiFp(this.configuration).getMetalAccount(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MetalPriceControllerApi - axios parameter creator
 */
export const MetalPriceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetalPrices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/metal-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetalPriceControllerApi - functional programming interface
 */
export const MetalPriceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetalPriceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMetalPrices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetalPrice>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMetalPrices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetalPriceControllerApi.getMetalPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MetalPriceControllerApi - factory interface
 */
export const MetalPriceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetalPriceControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetalPrices(options?: RawAxiosRequestConfig): AxiosPromise<MetalPrice> {
            return localVarFp.getMetalPrices(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetalPriceControllerApi - object-oriented interface
 */
export class MetalPriceControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMetalPrices(options?: RawAxiosRequestConfig) {
        return MetalPriceControllerApiFp(this.configuration).getMetalPrices(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderCustomerControllerApi - axios parameter creator
 */
export const OrderCustomerControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {SalesOrg} [salesOrg] 
         * @param {string} [filter] 
         * @param {string} [userId] 
         * @param {FilterOrdersOrderStatusEnum} [orderStatus] 
         * @param {boolean} [legacy] 
         * @param {MailjetSemaphorStatus} [emailStatus] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterOrders: async (fromDate?: string, toDate?: string, salesOrg?: SalesOrg, filter?: string, userId?: string, orderStatus?: FilterOrdersOrderStatusEnum, legacy?: boolean, emailStatus?: MailjetSemaphorStatus, page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/orders/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substring(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substring(0,10) :
                    toDate;
            }

            if (salesOrg !== undefined) {
                localVarQueryParameter['salesOrg'] = salesOrg;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (orderStatus !== undefined) {
                localVarQueryParameter['orderStatus'] = orderStatus;
            }

            if (legacy !== undefined) {
                localVarQueryParameter['legacy'] = legacy;
            }

            if (emailStatus !== undefined) {
                localVarQueryParameter['emailStatus'] = emailStatus;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} docItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDownloadInvoice: async (id: string, docItemId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('generateDownloadInvoice', 'id', id)
            // verify required parameter 'docItemId' is not null or undefined
            assertParamExists('generateDownloadInvoice', 'docItemId', docItemId)
            const localVarPath = `/protected/orders/{id}/invoice/{docItemId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"docItemId"}}`, encodeURIComponent(String(docItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDownloadRingoPdf: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('generateDownloadRingoPdf', 'id', id)
            const localVarPath = `/protected/orders/{id}/ringo-pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrder', 'id', id)
            const localVarPath = `/protected/orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderInvoiceList: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrderInvoiceList', 'id', id)
            const localVarPath = `/protected/orders/{id}/invoice`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRingStatusList: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRingStatusList', 'id', id)
            const localVarPath = `/protected/orders/{id}/ring-status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderCustomerControllerApi - functional programming interface
 */
export const OrderCustomerControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderCustomerControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {SalesOrg} [salesOrg] 
         * @param {string} [filter] 
         * @param {string} [userId] 
         * @param {FilterOrdersOrderStatusEnum} [orderStatus] 
         * @param {boolean} [legacy] 
         * @param {MailjetSemaphorStatus} [emailStatus] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filterOrders(fromDate?: string, toDate?: string, salesOrg?: SalesOrg, filter?: string, userId?: string, orderStatus?: FilterOrdersOrderStatusEnum, legacy?: boolean, emailStatus?: MailjetSemaphorStatus, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestPageOrderDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filterOrders(fromDate, toDate, salesOrg, filter, userId, orderStatus, legacy, emailStatus, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderCustomerControllerApi.filterOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} docItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateDownloadInvoice(id: string, docItemId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DownloadToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateDownloadInvoice(id, docItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderCustomerControllerApi.generateDownloadInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateDownloadRingoPdf(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DownloadToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateDownloadRingoPdf(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderCustomerControllerApi.generateDownloadRingoPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrder(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrder(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderCustomerControllerApi.getOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderInvoiceList(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Invoice>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderInvoiceList(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderCustomerControllerApi.getOrderInvoiceList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRingStatusList(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RingStatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRingStatusList(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderCustomerControllerApi.getRingStatusList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderCustomerControllerApi - factory interface
 */
export const OrderCustomerControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderCustomerControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [fromDate] 
         * @param {string} [toDate] 
         * @param {SalesOrg} [salesOrg] 
         * @param {string} [filter] 
         * @param {string} [userId] 
         * @param {FilterOrdersOrderStatusEnum} [orderStatus] 
         * @param {boolean} [legacy] 
         * @param {MailjetSemaphorStatus} [emailStatus] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterOrders(fromDate?: string, toDate?: string, salesOrg?: SalesOrg, filter?: string, userId?: string, orderStatus?: FilterOrdersOrderStatusEnum, legacy?: boolean, emailStatus?: MailjetSemaphorStatus, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<RestPageOrderDTO> {
            return localVarFp.filterOrders(fromDate, toDate, salesOrg, filter, userId, orderStatus, legacy, emailStatus, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} docItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDownloadInvoice(id: string, docItemId: string, options?: RawAxiosRequestConfig): AxiosPromise<DownloadToken> {
            return localVarFp.generateDownloadInvoice(id, docItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateDownloadRingoPdf(id: string, options?: RawAxiosRequestConfig): AxiosPromise<DownloadToken> {
            return localVarFp.generateDownloadRingoPdf(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrder(id: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderDTO> {
            return localVarFp.getOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderInvoiceList(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Invoice> {
            return localVarFp.getOrderInvoiceList(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRingStatusList(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RingStatus>> {
            return localVarFp.getRingStatusList(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderCustomerControllerApi - object-oriented interface
 */
export class OrderCustomerControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [fromDate] 
     * @param {string} [toDate] 
     * @param {SalesOrg} [salesOrg] 
     * @param {string} [filter] 
     * @param {string} [userId] 
     * @param {FilterOrdersOrderStatusEnum} [orderStatus] 
     * @param {boolean} [legacy] 
     * @param {MailjetSemaphorStatus} [emailStatus] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public filterOrders(fromDate?: string, toDate?: string, salesOrg?: SalesOrg, filter?: string, userId?: string, orderStatus?: FilterOrdersOrderStatusEnum, legacy?: boolean, emailStatus?: MailjetSemaphorStatus, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig) {
        return OrderCustomerControllerApiFp(this.configuration).filterOrders(fromDate, toDate, salesOrg, filter, userId, orderStatus, legacy, emailStatus, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} docItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateDownloadInvoice(id: string, docItemId: string, options?: RawAxiosRequestConfig) {
        return OrderCustomerControllerApiFp(this.configuration).generateDownloadInvoice(id, docItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generateDownloadRingoPdf(id: string, options?: RawAxiosRequestConfig) {
        return OrderCustomerControllerApiFp(this.configuration).generateDownloadRingoPdf(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrder(id: string, options?: RawAxiosRequestConfig) {
        return OrderCustomerControllerApiFp(this.configuration).getOrder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrderInvoiceList(id: string, options?: RawAxiosRequestConfig) {
        return OrderCustomerControllerApiFp(this.configuration).getOrderInvoiceList(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRingStatusList(id: string, options?: RawAxiosRequestConfig) {
        return OrderCustomerControllerApiFp(this.configuration).getRingStatusList(id, options).then((request) => request(this.axios, this.basePath));
    }
}

export const FilterOrdersOrderStatusEnum = {
    Initial: 'INITIAL',
    Ordered: 'ORDERED',
    InProgress: 'IN_PROGRESS',
    Complete: 'COMPLETE',
    Cancelled: 'CANCELLED'
} as const;
export type FilterOrdersOrderStatusEnum = typeof FilterOrdersOrderStatusEnum[keyof typeof FilterOrdersOrderStatusEnum];


/**
 * PriceMonitoringControllerApi - axios parameter creator
 */
export const PriceMonitoringControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SimulationRequest} simulationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateCartPrice: async (simulationRequest: SimulationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'simulationRequest' is not null or undefined
            assertParamExists('simulateCartPrice', 'simulationRequest', simulationRequest)
            const localVarPath = `/monitoring/cart/price-simulation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(simulationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PriceMonitoringControllerApi - functional programming interface
 */
export const PriceMonitoringControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PriceMonitoringControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SimulationRequest} simulationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async simulateCartPrice(simulationRequest: SimulationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.simulateCartPrice(simulationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PriceMonitoringControllerApi.simulateCartPrice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PriceMonitoringControllerApi - factory interface
 */
export const PriceMonitoringControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PriceMonitoringControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {SimulationRequest} simulationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateCartPrice(simulationRequest: SimulationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ShoppingCartDTO> {
            return localVarFp.simulateCartPrice(simulationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PriceMonitoringControllerApi - object-oriented interface
 */
export class PriceMonitoringControllerApi extends BaseAPI {
    /**
     * 
     * @param {SimulationRequest} simulationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public simulateCartPrice(simulationRequest: SimulationRequest, options?: RawAxiosRequestConfig) {
        return PriceMonitoringControllerApiFp(this.configuration).simulateCartPrice(simulationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PublicImageControllerApi - axios parameter creator
 */
export const PublicImageControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImage: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getImage', 'id', id)
            const localVarPath = `/public/image/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicImageControllerApi - functional programming interface
 */
export const PublicImageControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicImageControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImage(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImage(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicImageControllerApi.getImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PublicImageControllerApi - factory interface
 */
export const PublicImageControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicImageControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImage(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getImage(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicImageControllerApi - object-oriented interface
 */
export class PublicImageControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getImage(id: string, options?: RawAxiosRequestConfig) {
        return PublicImageControllerApiFp(this.configuration).getImage(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PublicNewsletterControllerApi - axios parameter creator
 */
export const PublicNewsletterControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmSubscribe: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('confirmSubscribe', 'token', token)
            const localVarPath = `/public/newsletter/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Subscribe} subscribe 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe: async (subscribe: Subscribe, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscribe' is not null or undefined
            assertParamExists('subscribe', 'subscribe', subscribe)
            const localVarPath = `/public/newsletter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscribe, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicNewsletterControllerApi - functional programming interface
 */
export const PublicNewsletterControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicNewsletterControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmSubscribe(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmSubscribe(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicNewsletterControllerApi.confirmSubscribe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Subscribe} subscribe 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribe(subscribe: Subscribe, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribe(subscribe, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicNewsletterControllerApi.subscribe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PublicNewsletterControllerApi - factory interface
 */
export const PublicNewsletterControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicNewsletterControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmSubscribe(token: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.confirmSubscribe(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Subscribe} subscribe 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe(subscribe: Subscribe, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.subscribe(subscribe, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicNewsletterControllerApi - object-oriented interface
 */
export class PublicNewsletterControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public confirmSubscribe(token: string, options?: RawAxiosRequestConfig) {
        return PublicNewsletterControllerApiFp(this.configuration).confirmSubscribe(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Subscribe} subscribe 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public subscribe(subscribe: Subscribe, options?: RawAxiosRequestConfig) {
        return PublicNewsletterControllerApiFp(this.configuration).subscribe(subscribe, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RingImageControllerApi - axios parameter creator
 */
export const RingImageControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRingImage: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRingImage', 'id', id)
            const localVarPath = `/protected/ring-image/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RingImageControllerApi - functional programming interface
 */
export const RingImageControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RingImageControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRingImage(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRingImage(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RingImageControllerApi.getRingImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RingImageControllerApi - factory interface
 */
export const RingImageControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RingImageControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRingImage(id: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getRingImage(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RingImageControllerApi - object-oriented interface
 */
export class RingImageControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRingImage(id: string, options?: RawAxiosRequestConfig) {
        return RingImageControllerApiFp(this.configuration).getRingImage(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SapHealthControllerApi - axios parameter creator
 */
export const SapHealthControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSapHealthStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/sap/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SapHealthControllerApi - functional programming interface
 */
export const SapHealthControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SapHealthControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSapHealthStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SapHealthStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSapHealthStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SapHealthControllerApi.getSapHealthStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SapHealthControllerApi - factory interface
 */
export const SapHealthControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SapHealthControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSapHealthStatus(options?: RawAxiosRequestConfig): AxiosPromise<SapHealthStatus> {
            return localVarFp.getSapHealthStatus(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SapHealthControllerApi - object-oriented interface
 */
export class SapHealthControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSapHealthStatus(options?: RawAxiosRequestConfig) {
        return SapHealthControllerApiFp(this.configuration).getSapHealthStatus(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SettingsControllerApi - axios parameter creator
 */
export const SettingsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinimumDeliverDays: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/settings/minimum-deliver-days`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSetting: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingsControllerApi - functional programming interface
 */
export const SettingsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMinimumDeliverDays(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMinimumDeliverDays(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsControllerApi.getMinimumDeliverDays']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSetting(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SettingsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSetting(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SettingsControllerApi.getSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SettingsControllerApi - factory interface
 */
export const SettingsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMinimumDeliverDays(options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.getMinimumDeliverDays(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSetting(options?: RawAxiosRequestConfig): AxiosPromise<SettingsDTO> {
            return localVarFp.getSetting(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SettingsControllerApi - object-oriented interface
 */
export class SettingsControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMinimumDeliverDays(options?: RawAxiosRequestConfig) {
        return SettingsControllerApiFp(this.configuration).getMinimumDeliverDays(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSetting(options?: RawAxiosRequestConfig) {
        return SettingsControllerApiFp(this.configuration).getSetting(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ShippingDateControllerApi - axios parameter creator
 */
export const ShippingDateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShippingDates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/shipping-dates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShippingDateControllerApi - functional programming interface
 */
export const ShippingDateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShippingDateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShippingDates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShippingDateDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShippingDates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShippingDateControllerApi.getShippingDates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ShippingDateControllerApi - factory interface
 */
export const ShippingDateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShippingDateControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShippingDates(options?: RawAxiosRequestConfig): AxiosPromise<Array<ShippingDateDTO>> {
            return localVarFp.getShippingDates(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShippingDateControllerApi - object-oriented interface
 */
export class ShippingDateControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getShippingDates(options?: RawAxiosRequestConfig) {
        return ShippingDateControllerApiFp(this.configuration).getShippingDates(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ShoppingCartControllerApi - axios parameter creator
 */
export const ShoppingCartControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<AddShoppingCartItemDTO>} addShoppingCartItemDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBulk: async (addShoppingCartItemDTO: Array<AddShoppingCartItemDTO>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addShoppingCartItemDTO' is not null or undefined
            assertParamExists('addBulk', 'addShoppingCartItemDTO', addShoppingCartItemDTO)
            const localVarPath = `/protected/shopping-cart/add-bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addShoppingCartItemDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddShoppingCartItemDTO} addShoppingCartItemDTO 
         * @param {AddItemToShoppingCartItemAddBehaviorEnum} [itemAddBehavior] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToShoppingCart: async (addShoppingCartItemDTO: AddShoppingCartItemDTO, itemAddBehavior?: AddItemToShoppingCartItemAddBehaviorEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addShoppingCartItemDTO' is not null or undefined
            assertParamExists('addItemToShoppingCart', 'addShoppingCartItemDTO', addShoppingCartItemDTO)
            const localVarPath = `/protected/shopping-cart/add-item`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (itemAddBehavior !== undefined) {
                localVarQueryParameter['itemAddBehavior'] = itemAddBehavior;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addShoppingCartItemDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShoppingCart: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/shopping-cart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShoppingCart: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/shopping-cart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlaceOrderDTO} placeOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeOrder: async (placeOrderDTO: PlaceOrderDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placeOrderDTO' is not null or undefined
            assertParamExists('placeOrder', 'placeOrderDTO', placeOrderDTO)
            const localVarPath = `/protected/shopping-cart/place-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placeOrderDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/shopping-cart/recalculate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeItemFromShoppingCart: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeItemFromShoppingCart', 'id', id)
            const localVarPath = `/protected/shopping-cart/remove-item/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetCommissionNumberDto} setCommissionNumberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCartCommissionNumber: async (setCommissionNumberDto: SetCommissionNumberDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setCommissionNumberDto' is not null or undefined
            assertParamExists('setCartCommissionNumber', 'setCommissionNumberDto', setCommissionNumberDto)
            const localVarPath = `/protected/shopping-cart/set-commission-number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setCommissionNumberDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetNoteDto} setNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCartNote: async (setNoteDto: SetNoteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setNoteDto' is not null or undefined
            assertParamExists('setCartNote', 'setNoteDto', setNoteDto)
            const localVarPath = `/protected/shopping-cart/set-note`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SetCommissionNumberDto} setCommissionNumberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCommissionNumber: async (id: string, setCommissionNumberDto: SetCommissionNumberDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setCommissionNumber', 'id', id)
            // verify required parameter 'setCommissionNumberDto' is not null or undefined
            assertParamExists('setCommissionNumber', 'setCommissionNumberDto', setCommissionNumberDto)
            const localVarPath = `/protected/shopping-cart/set-commission-number/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setCommissionNumberDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {number} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setItemQuantityRing1: async (id: string, body: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setItemQuantityRing1', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('setItemQuantityRing1', 'body', body)
            const localVarPath = `/protected/shopping-cart/set-quantity-ring-1/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {number} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setItemQuantityRing2: async (id: string, body: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setItemQuantityRing2', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('setItemQuantityRing2', 'body', body)
            const localVarPath = `/protected/shopping-cart/set-quantity-ring-2/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {SetNoteDto} setNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNote: async (id: string, setNoteDto: SetNoteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setNote', 'id', id)
            // verify required parameter 'setNoteDto' is not null or undefined
            assertParamExists('setNote', 'setNoteDto', setNoteDto)
            const localVarPath = `/protected/shopping-cart/set-note/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShoppingCartControllerApi - functional programming interface
 */
export const ShoppingCartControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShoppingCartControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<AddShoppingCartItemDTO>} addShoppingCartItemDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBulk(addShoppingCartItemDTO: Array<AddShoppingCartItemDTO>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBulk(addShoppingCartItemDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShoppingCartControllerApi.addBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AddShoppingCartItemDTO} addShoppingCartItemDTO 
         * @param {AddItemToShoppingCartItemAddBehaviorEnum} [itemAddBehavior] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addItemToShoppingCart(addShoppingCartItemDTO: AddShoppingCartItemDTO, itemAddBehavior?: AddItemToShoppingCartItemAddBehaviorEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addItemToShoppingCart(addShoppingCartItemDTO, itemAddBehavior, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShoppingCartControllerApi.addItemToShoppingCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteShoppingCart(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteShoppingCart(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShoppingCartControllerApi.deleteShoppingCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShoppingCart(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShoppingCartDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShoppingCart(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShoppingCartControllerApi.getShoppingCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PlaceOrderDTO} placeOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placeOrder(placeOrderDTO: PlaceOrderDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placeOrder(placeOrderDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShoppingCartControllerApi.placeOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recalculate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recalculate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShoppingCartControllerApi.recalculate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeItemFromShoppingCart(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeItemFromShoppingCart(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShoppingCartControllerApi.removeItemFromShoppingCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SetCommissionNumberDto} setCommissionNumberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCartCommissionNumber(setCommissionNumberDto: SetCommissionNumberDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCartCommissionNumber(setCommissionNumberDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShoppingCartControllerApi.setCartCommissionNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SetNoteDto} setNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCartNote(setNoteDto: SetNoteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCartNote(setNoteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShoppingCartControllerApi.setCartNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {SetCommissionNumberDto} setCommissionNumberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCommissionNumber(id: string, setCommissionNumberDto: SetCommissionNumberDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCommissionNumber(id, setCommissionNumberDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShoppingCartControllerApi.setCommissionNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {number} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setItemQuantityRing1(id: string, body: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setItemQuantityRing1(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShoppingCartControllerApi.setItemQuantityRing1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {number} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setItemQuantityRing2(id: string, body: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setItemQuantityRing2(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShoppingCartControllerApi.setItemQuantityRing2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {SetNoteDto} setNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setNote(id: string, setNoteDto: SetNoteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setNote(id, setNoteDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ShoppingCartControllerApi.setNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ShoppingCartControllerApi - factory interface
 */
export const ShoppingCartControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShoppingCartControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<AddShoppingCartItemDTO>} addShoppingCartItemDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBulk(addShoppingCartItemDTO: Array<AddShoppingCartItemDTO>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addBulk(addShoppingCartItemDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddShoppingCartItemDTO} addShoppingCartItemDTO 
         * @param {AddItemToShoppingCartItemAddBehaviorEnum} [itemAddBehavior] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToShoppingCart(addShoppingCartItemDTO: AddShoppingCartItemDTO, itemAddBehavior?: AddItemToShoppingCartItemAddBehaviorEnum, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addItemToShoppingCart(addShoppingCartItemDTO, itemAddBehavior, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShoppingCart(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteShoppingCart(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShoppingCart(options?: RawAxiosRequestConfig): AxiosPromise<ShoppingCartDTO> {
            return localVarFp.getShoppingCart(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlaceOrderDTO} placeOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeOrder(placeOrderDTO: PlaceOrderDTO, options?: RawAxiosRequestConfig): AxiosPromise<OrderDTO> {
            return localVarFp.placeOrder(placeOrderDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recalculate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeItemFromShoppingCart(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeItemFromShoppingCart(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetCommissionNumberDto} setCommissionNumberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCartCommissionNumber(setCommissionNumberDto: SetCommissionNumberDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setCartCommissionNumber(setCommissionNumberDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetNoteDto} setNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCartNote(setNoteDto: SetNoteDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setCartNote(setNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {SetCommissionNumberDto} setCommissionNumberDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCommissionNumber(id: string, setCommissionNumberDto: SetCommissionNumberDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setCommissionNumber(id, setCommissionNumberDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {number} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setItemQuantityRing1(id: string, body: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setItemQuantityRing1(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {number} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setItemQuantityRing2(id: string, body: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setItemQuantityRing2(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {SetNoteDto} setNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setNote(id: string, setNoteDto: SetNoteDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setNote(id, setNoteDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShoppingCartControllerApi - object-oriented interface
 */
export class ShoppingCartControllerApi extends BaseAPI {
    /**
     * 
     * @param {Array<AddShoppingCartItemDTO>} addShoppingCartItemDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addBulk(addShoppingCartItemDTO: Array<AddShoppingCartItemDTO>, options?: RawAxiosRequestConfig) {
        return ShoppingCartControllerApiFp(this.configuration).addBulk(addShoppingCartItemDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddShoppingCartItemDTO} addShoppingCartItemDTO 
     * @param {AddItemToShoppingCartItemAddBehaviorEnum} [itemAddBehavior] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addItemToShoppingCart(addShoppingCartItemDTO: AddShoppingCartItemDTO, itemAddBehavior?: AddItemToShoppingCartItemAddBehaviorEnum, options?: RawAxiosRequestConfig) {
        return ShoppingCartControllerApiFp(this.configuration).addItemToShoppingCart(addShoppingCartItemDTO, itemAddBehavior, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteShoppingCart(options?: RawAxiosRequestConfig) {
        return ShoppingCartControllerApiFp(this.configuration).deleteShoppingCart(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getShoppingCart(options?: RawAxiosRequestConfig) {
        return ShoppingCartControllerApiFp(this.configuration).getShoppingCart(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlaceOrderDTO} placeOrderDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placeOrder(placeOrderDTO: PlaceOrderDTO, options?: RawAxiosRequestConfig) {
        return ShoppingCartControllerApiFp(this.configuration).placeOrder(placeOrderDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public recalculate(options?: RawAxiosRequestConfig) {
        return ShoppingCartControllerApiFp(this.configuration).recalculate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeItemFromShoppingCart(id: string, options?: RawAxiosRequestConfig) {
        return ShoppingCartControllerApiFp(this.configuration).removeItemFromShoppingCart(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetCommissionNumberDto} setCommissionNumberDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setCartCommissionNumber(setCommissionNumberDto: SetCommissionNumberDto, options?: RawAxiosRequestConfig) {
        return ShoppingCartControllerApiFp(this.configuration).setCartCommissionNumber(setCommissionNumberDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetNoteDto} setNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setCartNote(setNoteDto: SetNoteDto, options?: RawAxiosRequestConfig) {
        return ShoppingCartControllerApiFp(this.configuration).setCartNote(setNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {SetCommissionNumberDto} setCommissionNumberDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setCommissionNumber(id: string, setCommissionNumberDto: SetCommissionNumberDto, options?: RawAxiosRequestConfig) {
        return ShoppingCartControllerApiFp(this.configuration).setCommissionNumber(id, setCommissionNumberDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {number} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setItemQuantityRing1(id: string, body: number, options?: RawAxiosRequestConfig) {
        return ShoppingCartControllerApiFp(this.configuration).setItemQuantityRing1(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {number} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setItemQuantityRing2(id: string, body: number, options?: RawAxiosRequestConfig) {
        return ShoppingCartControllerApiFp(this.configuration).setItemQuantityRing2(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {SetNoteDto} setNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setNote(id: string, setNoteDto: SetNoteDto, options?: RawAxiosRequestConfig) {
        return ShoppingCartControllerApiFp(this.configuration).setNote(id, setNoteDto, options).then((request) => request(this.axios, this.basePath));
    }
}

export const AddItemToShoppingCartItemAddBehaviorEnum = {
    MergeIfDuplicates: 'MERGE_IF_DUPLICATES',
    AddDuplicate: 'ADD_DUPLICATE',
    Replace: 'REPLACE'
} as const;
export type AddItemToShoppingCartItemAddBehaviorEnum = typeof AddItemToShoppingCartItemAddBehaviorEnum[keyof typeof AddItemToShoppingCartItemAddBehaviorEnum];


/**
 * TranslationControllerApi - axios parameter creator
 */
export const TranslationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {GetTranslationByLanguageLanguageEnum} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslationByLanguage: async (language: GetTranslationByLanguageLanguageEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getTranslationByLanguage', 'language', language)
            const localVarPath = `/public/translations/{language}/translation.json`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/translations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TranslationControllerApi - functional programming interface
 */
export const TranslationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TranslationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {GetTranslationByLanguageLanguageEnum} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranslationByLanguage(language: GetTranslationByLanguageLanguageEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranslationByLanguage(language, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslationControllerApi.getTranslationByLanguage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranslations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranslations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TranslationControllerApi.getTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TranslationControllerApi - factory interface
 */
export const TranslationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TranslationControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {GetTranslationByLanguageLanguageEnum} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslationByLanguage(language: GetTranslationByLanguageLanguageEnum, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getTranslationByLanguage(language, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranslations(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getTranslations(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TranslationControllerApi - object-oriented interface
 */
export class TranslationControllerApi extends BaseAPI {
    /**
     * 
     * @param {GetTranslationByLanguageLanguageEnum} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTranslationByLanguage(language: GetTranslationByLanguageLanguageEnum, options?: RawAxiosRequestConfig) {
        return TranslationControllerApiFp(this.configuration).getTranslationByLanguage(language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTranslations(options?: RawAxiosRequestConfig) {
        return TranslationControllerApiFp(this.configuration).getTranslations(options).then((request) => request(this.axios, this.basePath));
    }
}

export const GetTranslationByLanguageLanguageEnum = {
    En: 'EN',
    Fr: 'FR',
    De: 'DE',
    Es: 'ES',
    Sr: 'SR',
    Zh: 'ZH',
    Th: 'TH',
    Ko: 'KO',
    Ro: 'RO',
    Sl: 'SL',
    Hr: 'HR',
    Ms: 'MS',
    Uk: 'UK',
    Et: 'ET',
    Ar: 'AR',
    He: 'HE',
    Cz: 'CZ',
    El: 'EL',
    Hu: 'HU',
    It: 'IT',
    Ja: 'JA',
    Da: 'DA',
    Pl: 'PL',
    Zf: 'ZF',
    No: 'NO',
    Pt: 'PT',
    Sk: 'SK',
    Ru: 'RU',
    Tr: 'TR',
    Fi: 'FI',
    Sv: 'SV',
    Bg: 'BG',
    Lt: 'LT',
    Lv: 'LV',
    Z1: 'Z1',
    Af: 'AF',
    Is: 'IS',
    Ca: 'CA',
    Sh: 'SH',
    Id: 'ID',
    Nl: 'NL'
} as const;
export type GetTranslationByLanguageLanguageEnum = typeof GetTranslationByLanguageLanguageEnum[keyof typeof GetTranslationByLanguageLanguageEnum];


/**
 * UserControllerApi - axios parameter creator
 */
export const UserControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRoles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/users/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPrices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/users/prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserVerified: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/users/verified`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isSubscribeToNewsletter: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/users/subscribe-to-newsletter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserAnimation} userAnimation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAnimation: async (userAnimation: UserAnimation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAnimation' is not null or undefined
            assertParamExists('setAnimation', 'userAnimation', userAnimation)
            const localVarPath = `/protected/users/animation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userAnimation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubscribeToGoldzeitenDe} subscribeToGoldzeitenDe 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeToGoldzeiten: async (subscribeToGoldzeitenDe: SubscribeToGoldzeitenDe, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscribeToGoldzeitenDe' is not null or undefined
            assertParamExists('subscribeToGoldzeiten', 'subscribeToGoldzeitenDe', subscribeToGoldzeitenDe)
            const localVarPath = `/protected/users/subscribe-to-goldzeiten`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscribeToGoldzeitenDe, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SubscribeToHeimerleMeule} subscribeToHeimerleMeule 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeToHM: async (subscribeToHeimerleMeule: SubscribeToHeimerleMeule, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscribeToHeimerleMeule' is not null or undefined
            assertParamExists('subscribeToHM', 'subscribeToHeimerleMeule', subscribeToHeimerleMeule)
            const localVarPath = `/protected/users/subscribe-to-hm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscribeToHeimerleMeule, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCorrespondenceEmailsDto} updateCorrespondenceEmailsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCorrespondenceEmails: async (updateCorrespondenceEmailsDto: UpdateCorrespondenceEmailsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCorrespondenceEmailsDto' is not null or undefined
            assertParamExists('updateCorrespondenceEmails', 'updateCorrespondenceEmailsDto', updateCorrespondenceEmailsDto)
            const localVarPath = `/protected/users/correspondence-emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCorrespondenceEmailsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LanguageDTO} languageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLanguage: async (languageDTO: LanguageDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'languageDTO' is not null or undefined
            assertParamExists('updateLanguage', 'languageDTO', languageDTO)
            const localVarPath = `/protected/users/language`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(languageDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateMetalAccountOrderPreferenceDTO} updateMetalAccountOrderPreferenceDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMetalAccountOrderPreference: async (updateMetalAccountOrderPreferenceDTO: UpdateMetalAccountOrderPreferenceDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateMetalAccountOrderPreferenceDTO' is not null or undefined
            assertParamExists('updateMetalAccountOrderPreference', 'updateMetalAccountOrderPreferenceDTO', updateMetalAccountOrderPreferenceDTO)
            const localVarPath = `/protected/users/metal-account-order-preference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMetalAccountOrderPreferenceDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserPricesDTO} userPricesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPrices: async (userPricesDTO: UserPricesDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userPricesDTO' is not null or undefined
            assertParamExists('updateUserPrices', 'userPricesDTO', userPricesDTO)
            const localVarPath = `/protected/users/prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userPricesDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserControllerApi - functional programming interface
 */
export const UserControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRoles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRoles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getAllRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserPrices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPricesDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserPrices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getUserPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserVerified(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserVerified(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.getUserVerified']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isSubscribeToNewsletter(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Subscription>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isSubscribeToNewsletter(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.isSubscribeToNewsletter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserAnimation} userAnimation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAnimation(userAnimation: UserAnimation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAnimation(userAnimation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.setAnimation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SubscribeToGoldzeitenDe} subscribeToGoldzeitenDe 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeToGoldzeiten(subscribeToGoldzeitenDe: SubscribeToGoldzeitenDe, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeToGoldzeiten(subscribeToGoldzeitenDe, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.subscribeToGoldzeiten']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SubscribeToHeimerleMeule} subscribeToHeimerleMeule 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeToHM(subscribeToHeimerleMeule: SubscribeToHeimerleMeule, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeToHM(subscribeToHeimerleMeule, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.subscribeToHM']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateCorrespondenceEmailsDto} updateCorrespondenceEmailsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCorrespondenceEmails(updateCorrespondenceEmailsDto: UpdateCorrespondenceEmailsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCorrespondenceEmails(updateCorrespondenceEmailsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.updateCorrespondenceEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LanguageDTO} languageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLanguage(languageDTO: LanguageDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLanguage(languageDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.updateLanguage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateMetalAccountOrderPreferenceDTO} updateMetalAccountOrderPreferenceDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMetalAccountOrderPreference(updateMetalAccountOrderPreferenceDTO: UpdateMetalAccountOrderPreferenceDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMetalAccountOrderPreference(updateMetalAccountOrderPreferenceDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.updateMetalAccountOrderPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserPricesDTO} userPricesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPrices(userPricesDTO: UserPricesDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPrices(userPricesDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserControllerApi.updateUserPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserControllerApi - factory interface
 */
export const UserControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRoles(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getAllRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<UserDTO> {
            return localVarFp.getCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPrices(options?: RawAxiosRequestConfig): AxiosPromise<UserPricesDTO> {
            return localVarFp.getUserPrices(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserVerified(options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.getUserVerified(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isSubscribeToNewsletter(options?: RawAxiosRequestConfig): AxiosPromise<Subscription> {
            return localVarFp.isSubscribeToNewsletter(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserAnimation} userAnimation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAnimation(userAnimation: UserAnimation, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setAnimation(userAnimation, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscribeToGoldzeitenDe} subscribeToGoldzeitenDe 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeToGoldzeiten(subscribeToGoldzeitenDe: SubscribeToGoldzeitenDe, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.subscribeToGoldzeiten(subscribeToGoldzeitenDe, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SubscribeToHeimerleMeule} subscribeToHeimerleMeule 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeToHM(subscribeToHeimerleMeule: SubscribeToHeimerleMeule, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.subscribeToHM(subscribeToHeimerleMeule, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateCorrespondenceEmailsDto} updateCorrespondenceEmailsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCorrespondenceEmails(updateCorrespondenceEmailsDto: UpdateCorrespondenceEmailsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCorrespondenceEmails(updateCorrespondenceEmailsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LanguageDTO} languageDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLanguage(languageDTO: LanguageDTO, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateLanguage(languageDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateMetalAccountOrderPreferenceDTO} updateMetalAccountOrderPreferenceDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMetalAccountOrderPreference(updateMetalAccountOrderPreferenceDTO: UpdateMetalAccountOrderPreferenceDTO, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMetalAccountOrderPreference(updateMetalAccountOrderPreferenceDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserPricesDTO} userPricesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPrices(userPricesDTO: UserPricesDTO, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserPrices(userPricesDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserControllerApi - object-oriented interface
 */
export class UserControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllRoles(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getAllRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrentUser(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserPrices(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getUserPrices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserVerified(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).getUserVerified(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public isSubscribeToNewsletter(options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).isSubscribeToNewsletter(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserAnimation} userAnimation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setAnimation(userAnimation: UserAnimation, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).setAnimation(userAnimation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscribeToGoldzeitenDe} subscribeToGoldzeitenDe 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public subscribeToGoldzeiten(subscribeToGoldzeitenDe: SubscribeToGoldzeitenDe, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).subscribeToGoldzeiten(subscribeToGoldzeitenDe, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SubscribeToHeimerleMeule} subscribeToHeimerleMeule 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public subscribeToHM(subscribeToHeimerleMeule: SubscribeToHeimerleMeule, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).subscribeToHM(subscribeToHeimerleMeule, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateCorrespondenceEmailsDto} updateCorrespondenceEmailsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCorrespondenceEmails(updateCorrespondenceEmailsDto: UpdateCorrespondenceEmailsDto, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).updateCorrespondenceEmails(updateCorrespondenceEmailsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LanguageDTO} languageDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateLanguage(languageDTO: LanguageDTO, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).updateLanguage(languageDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateMetalAccountOrderPreferenceDTO} updateMetalAccountOrderPreferenceDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateMetalAccountOrderPreference(updateMetalAccountOrderPreferenceDTO: UpdateMetalAccountOrderPreferenceDTO, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).updateMetalAccountOrderPreference(updateMetalAccountOrderPreferenceDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserPricesDTO} userPricesDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUserPrices(userPricesDTO: UserPricesDTO, options?: RawAxiosRequestConfig) {
        return UserControllerApiFp(this.configuration).updateUserPrices(userPricesDTO, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserCouponControllerApi - axios parameter creator
 */
export const UserCouponControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApplyCouponRequest} applyCouponRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyCoupon: async (applyCouponRequest: ApplyCouponRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'applyCouponRequest' is not null or undefined
            assertParamExists('applyCoupon', 'applyCouponRequest', applyCouponRequest)
            const localVarPath = `/protected/coupons/shopping-cart/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyCouponRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCoupon: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/coupons/shopping-cart/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasAvailableCoupons: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/protected/coupons/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserCouponControllerApi - functional programming interface
 */
export const UserCouponControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserCouponControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ApplyCouponRequest} applyCouponRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyCoupon(applyCouponRequest: ApplyCouponRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplyCouponResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyCoupon(applyCouponRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserCouponControllerApi.applyCoupon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCoupon(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCoupon(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserCouponControllerApi.deleteCoupon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hasAvailableCoupons(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hasAvailableCoupons(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserCouponControllerApi.hasAvailableCoupons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserCouponControllerApi - factory interface
 */
export const UserCouponControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserCouponControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ApplyCouponRequest} applyCouponRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyCoupon(applyCouponRequest: ApplyCouponRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApplyCouponResponse> {
            return localVarFp.applyCoupon(applyCouponRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCoupon(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCoupon(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hasAvailableCoupons(options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.hasAvailableCoupons(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserCouponControllerApi - object-oriented interface
 */
export class UserCouponControllerApi extends BaseAPI {
    /**
     * 
     * @param {ApplyCouponRequest} applyCouponRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public applyCoupon(applyCouponRequest: ApplyCouponRequest, options?: RawAxiosRequestConfig) {
        return UserCouponControllerApiFp(this.configuration).applyCoupon(applyCouponRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteCoupon(options?: RawAxiosRequestConfig) {
        return UserCouponControllerApiFp(this.configuration).deleteCoupon(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public hasAvailableCoupons(options?: RawAxiosRequestConfig) {
        return UserCouponControllerApiFp(this.configuration).hasAvailableCoupons(options).then((request) => request(this.axios, this.basePath));
    }
}



